import React from 'react';
import {connect} from 'react-redux';
import util from 'Utils/commonUtil';

// Components
import Header from 'Components/common/Header';
import Anchor from 'Components/common/Anchor';
import Dialog from 'Components/common/Dialog';
import BasicButton from 'Components/common/BasicButton';
import BasicInput from 'Components/common/BasicInput';
import SearchInput from 'Components/common/SearchInput';
import ScrollWrapper from 'Components/common/ScrollWrapper';
import BackTop from 'Components/common/BackTop';
import ShipmentItem from './ShipmentItem';
import ShipmentCoaSuccessToast from './ShipmentCoaSuccessToast';
import ShipmentReceiveWithOtherPhotosDialog from './ShipmentReceiveWithOtherPhotosDialog';
import {
    ArrowDropDown,
    ArrowDropUp,
    Check,
    Description,
    KeyboardArrowRight,
} from '@material-ui/icons';
import {Checkbox} from '@material-ui/core';

// Actions
import {openNotification} from 'Actions/notification';
import {
    getOrderList,
    getShipmentList,
    notShipOrder,
    waitShipOrder,
    receiveOrder,
    checkOrderStatus,
    uploadReceiveImage,
    updateShipmentSearchFields,
    createRecommendPdf,
    updateTrackingNumber,
    getOrderDetailMessageCount,
    savePickOrder,
    forceCancelPickOrder,
    setShipmentsSource,
    updateShipmentListPageNum,
    getFeedbackList,
    feedbackSave,
    punchReceivable,
    setPunchSuccessStatus,
    setOrderRelatedTaskStatus,
    setRevokePackageSuccess,
    setCurrentShipmentId,
    updateShipmentList,
    b2bCasmartShipment,
    updateShipmentListTabActive,
    getShipmentDocumentCoa,
    checkShipmentCoaApplication,
    getShipmentProxyPdf,
    sendShipmentNotification,
} from 'Actions/host';
import {T} from 'Actions/translate';
import LoadingIcon from 'Components/icons/LoadingIcon';
import {loadLanguage, loadIdToken} from 'Utils/jwtUtil';

import {getTaskAssignmentListUrl, getSpecialTagListUrl} from 'Utils/urlUtil';
import {SHIPMENT_SORT, RECEIVE_METHOD} from 'Utils/constant';

const SHIPMENT_LIST_RESTORE_STORAGE_KEY = 'shipmentListRestoreState';

class ShipmentList extends React.Component {
    pager = {
        page: 0,
        length: 10,
        pageTotal: 9999999999999999999999999,
        total: 0,
    };

    inputFileRef = React.createRef();
    shipmentRestoreState = null;

    statusList = {
        1: T('to_send_the_goods'),
        2: T('shippment_temporary_not_delivery'),
        3: T('wait_for_receiving'),
        4: T('have_been_signed'),
        '-1': T('backup_status_RECALL'),
    };

    financialStatus = [
        {key: 1, value: T('no_lock')},
        {key: 2, value: T('locked')},
        {key: 3, value: T('all_order')},
    ];

    orderStatus = [
        {key: 4, value: T('order_in_stock')},
        {key: 5, value: T('no_stock')},
        {key: 6, value: T('all_order')},
    ];
    expressType = [
        {key: 7, value: T('direct_method')},
        {key: 8, value: T('mail_method')},
        {key: 9, value: T('all_order')},
    ];

    constructor(props) {
        super(props);
        this.state = {
            tabList: [
                {
                    index: 0,
                    text: T('to_send_the_goods'),
                    tabFlag: 1,
                    name: 'tobeShip',
                },
                {
                    index: 1,
                    text: T('temporary_not'),
                    tabFlag: 2,
                    name: 'onHold',
                },
                {
                    index: 2,
                    text: T('wait_for_receiving'),
                    tabFlag: 3,
                    name: 'receive',
                },
                {
                    index: 3,
                    text: T('off_the_stocks'),
                    tabFlag: 4,
                    name: 'complete',
                },
            ],
            financialOrdertabList: [
                {
                    index: 0,
                    text: T('financial_status'),
                    tabFlag: 1,
                    name: 'tobeFinancial',
                },
                {
                    index: 1,
                    text: T('order_status'),
                    tabFlag: 2,
                    name: 'onOrder',
                },
                {
                    index: 2,
                    text: T('express_type'),
                    tabFlag: 3,
                    name: 'expressType',
                },
            ],
            currentShipmentSort: SHIPMENT_SORT.ASC_SORT,
            subTabList: this.financialStatus,
            financialStatusDropUp: false,
            orderStatusDropUp: false,
            expressTypeDropUp: false,
            financialTabValue: this.financialStatus[0].value,
            orderTabValue: this.orderStatus[0].value,
            expressTypeValue: this.expressType[2].value,
            showLockinStatus: false,
            currentChecked: 1,
            tabActive: 0,
            subTabActive: 0,
            listLoaded: true,
            listLoadFailed: false,
            uploadReceiveImageDialog: {
                opened: false,
                shipment: null,
                chooseImage: {file: null, url: ''},
            },
            addTrackNumberDialogOpened: false,
            notShipDialogOpened: false,
            waitSendGoodsDialogOpened: false,
            chooseOrderItem: null,
            uploadFileBtnIsLoading: false,
            pageLoading: false,
            trackNumber: '',
            currentShipments: [],
            location: '',
            previewPickOrderDialog: false,
            currentOrderId: 0,
            currentDisplayPrice: 1,
            opentForceShipDialog: false,
            currentShipItem: {},
            showCasmatMessage: false,
            todayPlanChecked: true,
            showSpecialTagsDialogOpened: false,
            currentSpecialTagsList: [],
            otherInformantion: '',
            shipmentCoaDialogOpened: false,
            shipmentCoaLoading: false,
            shipmentCoaRows: [],
            shipmentCoaApplyDialogOpened: false,
            shipmentCoaApplyCheckPending: false,
            currentShipmentCoaRowForApply: null,
            currentShipmentOrderForCoaApply: null,
            shipmentCoaApplicationPromptDialogOpened: false,
            shipmentCoaApplicationPromptMessage: '',
            shipmentCoaSuccessToastVisible: false,
            isRestoringShipmentList: false,
        };
    }

    componentWillMount() {
        this.state.tabList.forEach((tab) => {
            if (
                this.props.match.params.tab.toLocaleLowerCase() ===
                tab.name.toLocaleLowerCase()
            ) {
                this.setState({tabActive: tab.index}, () => {
                    console.log('tab.index====================', tab.index);
                    this.props.updateShipmentListTabActive({
                        $set: this.getTabActiveValue(),
                    });
                    let financialCheckNum = 0;
                    let orderCheckNum = 0;
                    let expressCheckNum = 0;
                    if (localStorage.getItem('currentFinancialTabValue')) {
                        financialCheckNum = this.getCurrentFinancialCheckNum(
                            localStorage.getItem('currentFinancialTabValue'),
                        );
                    } else {
                        financialCheckNum = this.getCurrentFinancialCheckNum(
                            this.state.financialTabValue,
                        );
                    }
                    if (localStorage.getItem('currentOrderTabValue')) {
                        orderCheckNum = this.getCurrentOrderCheckNum(
                            localStorage.getItem('currentOrderTabValue'),
                        );
                    } else {
                        orderCheckNum = this.getCurrentOrderCheckNum(
                            this.state.orderTabValue,
                        );
                    }
                    if (localStorage.getItem('currentExpressTabValue')) {
                        expressCheckNum = this.getCurrentExpressTypeNum(
                            localStorage.getItem('currentExpressTabValue'),
                        );
                    } else {
                        expressCheckNum = this.getCurrentExpressTypeNum(
                            this.state.expressTypeValue,
                        );
                    }

                    this.setState({
                        financialTabValue: localStorage.getItem(
                            'currentFinancialTabValue',
                        )
                            ? localStorage.getItem('currentFinancialTabValue')
                            : this.state.financialTabValue,
                        orderTabValue: localStorage.getItem(
                            'currentOrderTabValue',
                        )
                            ? localStorage.getItem('currentOrderTabValue')
                            : this.state.orderTabValue,
                        expressTypeValue: localStorage.getItem(
                            'currentExpressTabValue',
                        )
                            ? localStorage.getItem('currentExpressTabValue')
                            : this.state.expressTypeValue,
                        currentShipmentSort: localStorage.getItem(
                            'currentSortResult',
                        )
                            ? localStorage.getItem('currentSortResult')
                            : this.state.currentShipmentSort,
                        todayPlanChecked: localStorage.getItem(
                            'currentTodayPlanChecked',
                        )
                            ? localStorage.getItem('currentTodayPlanChecked')
                            : this.state.todayPlanChecked,
                    });

                    const {tabList, tabActive} = this.state;
                    const {currentShipmentId} = this.props;
                    const currentTabName = tabList[tabActive].name;
                    const restoreState = this.getShipmentRestoreState();
                    const matchedRestoreState =
                        restoreState && restoreState.tab === currentTabName
                            ? restoreState
                            : null;

                    if (restoreState && !matchedRestoreState) {
                        this.clearRestoreState();
                    }

                    if (matchedRestoreState) {
                        const restoreFinancialTabValue =
                            matchedRestoreState.financialTabValue ||
                            this.state.financialTabValue;
                        const restoreOrderTabValue =
                            matchedRestoreState.orderTabValue ||
                            this.state.orderTabValue;
                        const restoreExpressTypeValue =
                            matchedRestoreState.expressTypeValue ||
                            this.state.expressTypeValue;
                        const restoreCurrentShipmentSort =
                            matchedRestoreState.currentShipmentSort ||
                            this.state.currentShipmentSort;
                        const restoreTodayPlanChecked =
                            typeof matchedRestoreState.todayPlanChecked ===
                            'boolean'
                                ? matchedRestoreState.todayPlanChecked
                                : this.state.todayPlanChecked;

                        financialCheckNum = this.getCurrentFinancialCheckNum(
                            restoreFinancialTabValue,
                        );
                        orderCheckNum =
                            this.getCurrentOrderCheckNum(restoreOrderTabValue);
                        expressCheckNum = this.getCurrentExpressTypeNum(
                            restoreExpressTypeValue,
                        );

                        this.saveShipmentFilterState({
                            financialTabValue: restoreFinancialTabValue,
                            orderTabValue: restoreOrderTabValue,
                            expressTypeValue: restoreExpressTypeValue,
                            currentShipmentSort: restoreCurrentShipmentSort,
                            todayPlanChecked: restoreTodayPlanChecked,
                        });

                        this.props.updateShipmentSearchFields({
                            queryKey: {
                                $set:
                                    typeof matchedRestoreState.queryKey ===
                                    'string'
                                        ? matchedRestoreState.queryKey
                                        : this.props.queryKey,
                            },
                        });
                        this.setState(
                            {
                                financialTabValue: restoreFinancialTabValue,
                                orderTabValue: restoreOrderTabValue,
                                expressTypeValue: restoreExpressTypeValue,
                                currentShipmentSort: restoreCurrentShipmentSort,
                                todayPlanChecked: restoreTodayPlanChecked,
                            },
                            () => {
                                this.restoreShipmentList(
                                    matchedRestoreState,
                                    financialCheckNum,
                                    orderCheckNum,
                                    expressCheckNum,
                                );
                            },
                        );
                    } else if (this.props.fromShipmentDetails) {
                        const currentTabShipmentList =
                            this.props.shipmentList[currentTabName] || [];

                        this.setState({
                            todayPlanChecked:
                                this.getStoredTodayPlanChecked(true),
                            currentShipmentSort:
                                localStorage.getItem('currentSortResult'),
                        });
                        this.props.setShipmentsSource({$set: false});

                        if (currentTabShipmentList.length > 0) {
                            this.pager.page = this.props.currentPageNum;
                        } else {
                            this.props.updateShipmentListPageNum({$set: 0});
                            this.resetPager();
                            this.getList(
                                financialCheckNum,
                                orderCheckNum,
                                expressCheckNum,
                            );
                        }
                    } else {
                        this.saveShipmentFilterState({
                            currentShipmentSort: SHIPMENT_SORT.ASC_SORT,
                            todayPlanChecked: true,
                        });

                        this.setState({
                            currentShipmentSort: SHIPMENT_SORT.ASC_SORT,
                            todayPlanChecked: true,
                        });
                        this.props.updateShipmentListPageNum({$set: 0});
                        this.pager.page = 0;
                        this.getList(
                            financialCheckNum,
                            orderCheckNum,
                            expressCheckNum,
                        );
                    }

                    if (this.props.revokePackageSuccessFlag) {
                        this.revokePackageHandle();
                    }

                    if (this.props.punchStatusFlag) {
                        let currentShipmentList = JSON.parse(
                            JSON.stringify(
                                this.props.shipmentList[
                                    tabList[tabActive].name
                                ],
                            ),
                        );

                        currentShipmentList.length > 0 &&
                            currentShipmentList.forEach((shipItem) => {
                                if (
                                    currentShipmentId ===
                                    shipItem.shipments[0].id
                                ) {
                                    shipItem.hasPunched = 'Y';
                                }
                            });
                        this.props.updateShipmentList({
                            currentShipmentList: currentShipmentList,
                            tab: tabList[tabActive].name,
                        });
                        this.props.setPunchSuccessStatus({$set: false});
                        this.pager.page = this.props.currentPageNum;
                    }

                    if (this.props.orderRelatedTaskFlag) {
                        const {currentStNumber} = this.props;
                        this.updateOrderRelatedTask(
                            tabList,
                            tabActive,
                            currentStNumber,
                        );
                    }
                });
            }
        });
    }

    componentWillUnmount() {
        if (this.shipmentCoaSuccessToastTimer) {
            clearTimeout(this.shipmentCoaSuccessToastTimer);
        }
    }

    resetPager = () => {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
    };

    getShipmentAnchorId = (item) => {
        if (!item || !item.id) return '';
        return `shipment-list-item-${item.id}`;
    };

    getShipmentRestoreState = () => {
        let restoreState = null;

        try {
            const restoreStateStr = sessionStorage.getItem(
                SHIPMENT_LIST_RESTORE_STORAGE_KEY,
            );

            if (restoreStateStr) {
                restoreState = JSON.parse(restoreStateStr);
            }
        } catch (err) {
            restoreState = null;
        }

        return restoreState;
    };

    clearRestoreState = () => {
        sessionStorage.removeItem(SHIPMENT_LIST_RESTORE_STORAGE_KEY);
        this.shipmentRestoreState = null;
    };

    getStoredTodayPlanChecked = (defaultValue = true) => {
        const storedTodayPlanChecked = localStorage.getItem(
            'currentTodayPlanChecked',
        );

        if (util.isString(storedTodayPlanChecked)) {
            if (storedTodayPlanChecked === 'false') {
                return false;
            }

            if (storedTodayPlanChecked === 'true') {
                return true;
            }
        }

        return defaultValue;
    };

    saveShipmentFilterState = (params = {}) => {
        const {
            financialTabValue = this.state.financialTabValue,
            orderTabValue = this.state.orderTabValue,
            expressTypeValue = this.state.expressTypeValue,
            currentShipmentSort = this.state.currentShipmentSort,
            todayPlanChecked = this.state.todayPlanChecked,
        } = params;

        localStorage.setItem('currentFinancialTabValue', financialTabValue);
        localStorage.setItem('currentOrderTabValue', orderTabValue);
        localStorage.setItem('currentExpressTabValue', expressTypeValue);
        localStorage.setItem('currentSortResult', currentShipmentSort);
        localStorage.setItem('currentTodayPlanChecked', todayPlanChecked);
    };

    saveShipmentRestoreState = (item) => {
        const currentItemPageNum = this.getShipmentItemPageNum(item);
        const isCurrentPageLastItem =
            this.getShipmentItemIsCurrentPageLast(item);
        const isCurrentPageSecondLastItem =
            this.getShipmentItemIsCurrentPageSecondLast(item);

        this.saveShipmentFilterState();
        sessionStorage.setItem(
            SHIPMENT_LIST_RESTORE_STORAGE_KEY,
            JSON.stringify({
                pageNum: currentItemPageNum,
                orderNumber: item.number,
                isCurrentPageLastItem,
                isCurrentPageSecondLastItem,
                tab: this.getTabActiveValue(),
                queryKey: this.props.queryKey,
                financialTabValue: this.state.financialTabValue,
                orderTabValue: this.state.orderTabValue,
                expressTypeValue: this.state.expressTypeValue,
                currentShipmentSort: this.state.currentShipmentSort,
                todayPlanChecked: this.state.todayPlanChecked,
            }),
        );
        this.props.updateShipmentListPageNum({$set: currentItemPageNum});
    };

    handleGetMoreData = () => {
        if (
            this.state.isRestoringShipmentList &&
            !this.shouldAllowLoadMoreDuringRestore()
        ) {
            return;
        }

        this.getList();
    };

    retryGetList = () => {
        const financialCheckNum = this.getCurrentFinancialCheckNum(
            this.state.financialTabValue,
        );
        const orderCheckNum = this.getCurrentOrderCheckNum(
            this.state.orderTabValue,
        );
        const expressCheckNum = this.getCurrentExpressTypeNum(
            this.state.expressTypeValue,
        );

        this.resetPager();
        return this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
    };

    getCurrentTabShipmentList = () => {
        const {tabList, tabActive} = this.state;
        return this.props.shipmentList[tabList[tabActive].name] || [];
    };

    getShipmentItemPageNum = (item) => {
        const shipmentList = this.getCurrentTabShipmentList();
        const currentItemIndex = shipmentList.findIndex((shipmentItem) => {
            if (shipmentItem.id && item.id) {
                return shipmentItem.id === item.id;
            }

            return shipmentItem.number === item.number;
        });

        if (currentItemIndex < 0) {
            return this.pager.page || 1;
        }

        return Math.floor(currentItemIndex / this.pager.length) + 1;
    };

    getShipmentItemIsCurrentPageLast = (item) => {
        const shipmentList = this.getCurrentTabShipmentList();
        const currentItemIndex = shipmentList.findIndex((shipmentItem) => {
            if (shipmentItem.id && item.id) {
                return shipmentItem.id === item.id;
            }

            return shipmentItem.number === item.number;
        });

        if (currentItemIndex < 0) {
            return false;
        }

        return (currentItemIndex + 1) % this.pager.length === 0;
    };

    getShipmentItemIsCurrentPageSecondLast = (item) => {
        const shipmentList = this.getCurrentTabShipmentList();
        const currentItemIndex = shipmentList.findIndex((shipmentItem) => {
            if (shipmentItem.id && item.id) {
                return shipmentItem.id === item.id;
            }

            return shipmentItem.number === item.number;
        });

        if (currentItemIndex < 0) {
            return false;
        }

        return (currentItemIndex + 2) % this.pager.length === 0;
    };

    shouldAllowLoadMoreDuringRestore = () => {
        if (!this.state.isRestoringShipmentList || !this.shipmentRestoreState) {
            return false;
        }

        console.log(
            'this.shipmentRestoreState.isCurrentPageSecondLastItem',
            this.shipmentRestoreState.isCurrentPageSecondLastItem,
        );
        return (
            (this.shipmentRestoreState.isCurrentPageLastItem === true ||
                (this.shipmentRestoreState.pageNum === 1 &&
                    this.shipmentRestoreState.isCurrentPageSecondLastItem ===
                        true)) &&
            this.pager.page >= this.shipmentRestoreState.pageNum
        );
    };

    getRestoreTargetItem = () => {
        const shipmentList = this.getCurrentTabShipmentList();

        if (!this.shipmentRestoreState || shipmentList.length <= 0) {
            return null;
        }

        const {orderNumber, pageNum} = this.shipmentRestoreState;
        const currentPageNum = Math.max(
            Math.min(this.pager.page || pageNum, pageNum),
            1,
        );
        const pageStartIndex = Math.max(
            (currentPageNum - 1) * this.pager.length,
            0,
        );
        const currentPageShipmentList = shipmentList.slice(
            pageStartIndex,
            pageStartIndex + this.pager.length,
        );
        const currentOrderNumber = String(orderNumber || '').trim();
        const matchedItem = currentPageShipmentList.find(
            (item) => String(item.number || '').trim() === currentOrderNumber,
        );

        if (matchedItem) {
            return matchedItem;
        }

        const fallbackPageStartIndex =
            shipmentList.length > pageStartIndex
                ? pageStartIndex
                : Math.max(
                      (Math.ceil(shipmentList.length / this.pager.length) - 1) *
                          this.pager.length,
                      0,
                  );

        return (
            currentPageShipmentList[0] ||
            shipmentList[fallbackPageStartIndex] ||
            shipmentList[0]
        );
    };

    scrollToRestoreTarget = (retryCount = 0) => {
        const maxRetryCount = 20;

        window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
                const targetItem = this.getRestoreTargetItem();
                const targetElement = targetItem
                    ? document.getElementById(
                          this.getShipmentAnchorId(targetItem),
                      )
                    : null;

                if (!targetItem || !targetElement) {
                    if (retryCount < maxRetryCount) {
                        window.setTimeout(() => {
                            this.scrollToRestoreTarget(retryCount + 1);
                        }, 100);
                        return;
                    }

                    this.props.updateShipmentListPageNum({
                        $set: this.pager.page,
                    });
                    this.clearRestoreState();
                    this.setState({
                        isRestoringShipmentList: false,
                    });
                    return;
                }

                const headerContainer =
                    document.getElementById('header-container');
                const headerHeight = headerContainer
                    ? headerContainer.clientHeight
                    : 0;
                const safeOffset = 8;
                const positionTolerance = 12;
                const scrollTargetToAnchor = () => {
                    const currentScrollTop =
                        document.documentElement.scrollTop ||
                        document.body.scrollTop ||
                        0;
                    const targetTop =
                        targetElement.getBoundingClientRect().top +
                        currentScrollTop -
                        headerHeight -
                        safeOffset;

                    window.scrollTo(0, Math.max(targetTop, 0));
                };
                const checkIsAligned = () => {
                    const currentTop =
                        targetElement.getBoundingClientRect().top;
                    const expectedTop = headerHeight + safeOffset;

                    return (
                        Math.abs(currentTop - expectedTop) <= positionTolerance
                    );
                };

                scrollTargetToAnchor();

                window.setTimeout(() => {
                    scrollTargetToAnchor();

                    if (!checkIsAligned() && retryCount < maxRetryCount) {
                        window.setTimeout(() => {
                            this.scrollToRestoreTarget(retryCount + 1);
                        }, 120);
                        return;
                    }

                    this.props.updateShipmentListPageNum({
                        $set: this.pager.page,
                    });
                    this.clearRestoreState();
                    window.setTimeout(() => {
                        this.setState({
                            isRestoringShipmentList: false,
                        });
                    }, 120);
                }, 80);
            });
        });
    };

    restoreShipmentList = async (
        restoreState,
        financialCheckNum,
        orderCheckNum,
        expressCheckNum,
    ) => {
        const targetPageNum = Math.max(
            parseInt(restoreState.pageNum, 10) || 1,
            1,
        );
        this.shipmentRestoreState = {
            orderNumber: restoreState.orderNumber,
            pageNum: targetPageNum,
            isCurrentPageLastItem: restoreState.isCurrentPageLastItem === true,
            isCurrentPageSecondLastItem:
                restoreState.isCurrentPageSecondLastItem === true,
        };

        const shipmentList = this.getCurrentTabShipmentList();
        const targetPageStartIndex = Math.max(
            (targetPageNum - 1) * this.pager.length,
            0,
        );
        const cachedShipmentListPrefix =
            targetPageNum > 1
                ? shipmentList.slice(0, targetPageStartIndex)
                : [];
        const hasFullPrefixCache =
            targetPageNum === 1 ||
            cachedShipmentListPrefix.length === targetPageStartIndex;

        window.scrollTo(0, 0);
        this.setState({
            isRestoringShipmentList: true,
        });

        if (hasFullPrefixCache) {
            this.props.updateShipmentList({
                currentShipmentList: cachedShipmentListPrefix,
                tab: this.getTabActiveValue(),
            });
            this.pager.page = targetPageNum - 1;
            this.props.updateShipmentListPageNum({
                $set: targetPageNum - 1,
            });
            await this.getList(
                financialCheckNum,
                orderCheckNum,
                expressCheckNum,
            );
        } else {
            this.resetPager();
            this.props.updateShipmentListPageNum({$set: 0});
            while (
                this.pager.page < targetPageNum &&
                this.pager.page < this.pager.pageTotal
            ) {
                const currentPage = this.pager.page;
                const currentPageTotal = this.pager.pageTotal;

                await this.getList(
                    financialCheckNum,
                    orderCheckNum,
                    expressCheckNum,
                );

                // Stop restoring if the fetch did not advance pagination,
                // otherwise a failed request can loop forever here.
                if (
                    this.pager.page === currentPage &&
                    this.pager.pageTotal === currentPageTotal
                ) {
                    break;
                }
            }
        }

        this.scrollToRestoreTarget();
    };

    updateOrderRelatedTask = (tabList, tabActive, currentStNumber) => {
        let currentShipmentList = JSON.parse(
            JSON.stringify(this.props.shipmentList[tabList[tabActive].name]),
        );

        currentShipmentList.length > 0 &&
            currentShipmentList.forEach((shipItem) => {
                // 检查 shipItem.shipments 是否存在且有至少一个元素
                if (shipItem.shipToNum) {
                    const shipToNum = shipItem.shipToNum;

                    // 检查 shipmentId 是否存在
                    if (shipToNum !== undefined) {
                        // 检查 currentShipmentId 和 shipmentId 的值

                        // 比较时确保类型一致
                        if (currentStNumber && currentStNumber === shipToNum) {
                            shipItem.showOrderRelatedTask = false;
                        }
                    } else {
                        console.warn('shipItem.shipToNum is undefined');
                    }
                } else {
                    console.warn('shipItem.shipments is empty or undefined');
                }
            });
        // this.props.setCurrentShipmentId({$set: ''});
        this.props.updateShipmentList({
            currentShipmentList: currentShipmentList,
            tab: tabList[tabActive].name,
        });
        this.props.setOrderRelatedTaskStatus({$set: false});
        this.pager.page = this.props.currentPageNum;
    };

    revokePackageHandle = () => {
        const {tabList, tabActive} = this.state;
        const {currentShipmentId} = this.props;
        this.props.setRevokePackageSuccess({$set: false});
        let currentShipmentList = JSON.parse(
            JSON.stringify(this.props.shipmentList[tabList[tabActive].name]),
        );

        let newShipmentList = [];
        currentShipmentList.length > 0 &&
            currentShipmentList.forEach((shipItem) => {
                if (
                    currentShipmentId &&
                    currentShipmentId !== shipItem.shipments[0].id
                ) {
                    newShipmentList.push(shipItem);
                }
            });
        this.props.setCurrentShipmentId({$set: ''});
        this.props.updateShipmentList({
            currentShipmentList: newShipmentList,
            tab: tabList[tabActive].name,
        });
        this.pager.page = this.props.currentPageNum;
    };

    componentDidUpdate = () => {
        if (this.props.match.params.tab.toLocaleLowerCase() === 'tobeship') {
            this.onloadHeight();
        } else if (
            this.props.match.params.tab.toLocaleLowerCase() === 'onhold'
        ) {
            let tabFlag = 2;
            this.onloadHeight(tabFlag);
        }
    };

    fetchAndMergeData = () => {
        const {tabList, tabActive} = this.state;
        const currentTabName = tabList[tabActive].name;
        const shipmentList = this.props.shipmentList[currentTabName] || [];

        // 提取所有需要查询的 shipToNum
        const shipToNums = shipmentList
            .map((item) => item.shipToNum)
            .filter(Boolean);

        // 如果没有 shipToNum，直接返回
        if (shipToNums.length === 0) {
            console.log(
                'fetchAndMergeData updatedShipmentList===========================================',
                this.props.shipmentList,
            );
            return;
        }

        // 调用接口，一次性查询所有 shipToNum 的数据
        this.fetchDataFromApi(shipToNums)
            .then((apiData) => {
                // 将 apiData 转换为一个映射对象，方便后续查找
                const apiDataMap = apiData.reduce((acc, data) => {
                    acc[data.shipTo] = data;
                    return acc;
                }, {});

                // 更新 shipmentList
                const updatedItems = shipmentList.map((item) => {
                    if (item.shipToNum && apiDataMap[item.shipToNum]) {
                        // 如果找到匹配的 shipTo，合并数据
                        return {
                            ...item,
                            taskId: apiDataMap[item.shipToNum].taskId,
                            taskAssignmentId: apiDataMap[item.shipToNum].id,
                            showOrderRelatedTask: true,
                        };
                    }
                    return item; // 如果没有匹配，返回原始数据
                });

                const updatedShipmentList = {
                    ...this.props.shipmentList,
                    [currentTabName]: updatedItems,
                };

                // 在所有请求完成后再打印更新后的数据
                console.log(
                    'fetchAndMergeData updatedShipmentList===========================================',
                    updatedShipmentList,
                );

                // 更新 Redux 中的 shipmentList
                // this.props.updateShipmentList({
                //     currentShipmentList: updatedShipmentList.receive,
                //     tab: tabList[tabActive].name,
                // });

                this.fetchSpecialTagsData(updatedShipmentList);
            })
            .catch((error) => {
                console.error('处理数据时发生错误:', error);
            });
    };

    fetchDataFromApi = (shipToNums) => {
        // 去重处理：确保 shipToNums 中没有重复的值
        const uniqueShipToNums = [...new Set(shipToNums)];
        // 将 shipToNums 转换为请求参数
        const requestBody = {shipTos: uniqueShipToNums};

        // 使用 fetch 发送 POST 请求
        return fetch(getTaskAssignmentListUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Token: loadIdToken(),
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('接口调用失败，状态码：' + response.status);
                }
                return response.json();
            })
            .then((data) => {
                return data.data || []; // 假设接口返回的数据格式是 { data: [ { shipTo, taskId, id }, ... ] }
            })
            .catch((error) => {
                console.error('接口调用失败:', error);
                return []; // 如果请求失败，返回空数组
            });
    };

    fetchSpecialTagsData = (preUpdatedShipmentList) => {
        const {tabList, tabActive} = this.state;
        const currentTabName = tabList[tabActive].name;
        // const shipmentList = this.props.shipmentList[currentTabName] || [];
        const shipmentList = preUpdatedShipmentList[currentTabName] || [];

        // 提取所有需要查询的 shipToNum
        const shipToNums = shipmentList
            .map((item) => item.shipToNum)
            .filter(Boolean);

        // 如果没有 shipToNum，直接返回
        if (shipToNums.length === 0) {
            console.log(
                'fetchSpecialTagsData updatedShipmentList===========================================',
                this.props.shipmentList,
            );
            return;
        }

        // 调用接口，一次性查询所有 shipToNum 的数据
        this.fetchSpecialTagsDataFromApi(shipToNums)
            .then((apiData) => {
                // 更新 shipmentList
                const updatedItems = shipmentList.map((item) => {
                    // 在 apiData 中查找 shipTo 和 shipToNum 相等的项
                    const apiItem = apiData.find(
                        (apiItem) => apiItem.shipTo === item.shipToNum,
                    );
                    console.log(
                        'apiDataMap[item.shipToNum]=================apiItem',
                        apiItem,
                    );
                    if (apiItem) {
                        // 如果找到匹配的 shipTo，合并数据
                        return {
                            ...item,
                            adminSpecialList: apiItem.adminSpecialList,
                            hostSpecialList: apiItem.hostSpecialList,
                            hostExtend: apiItem.hostExtend,
                            showSpecialTagsFlag: true,
                        };
                    }
                    return item; // 如果没有匹配，返回原始数据
                });

                const updatedShipmentList = {
                    ...this.props.shipmentList,
                    [currentTabName]: updatedItems,
                };

                // 在所有请求完成后再打印更新后的数据
                console.log(
                    'fetchAndMergeData updatedShipmentList===========================================',
                    updatedShipmentList,
                );

                // 更新 Redux 中的 shipmentList
                this.props.updateShipmentList({
                    currentShipmentList: updatedShipmentList.receive,
                    tab: tabList[tabActive].name,
                });
            })
            .catch((error) => {
                console.error('处理数据时发生错误:', error);
            });
    };

    fetchSpecialTagsDataFromApi = (shipToNums) => {
        // 去重处理：确保 shipToNums 中没有重复的值
        const uniqueShipToNums = [...new Set(shipToNums)];
        // 将 shipToNums 转换为请求参数
        const requestBody = {shipTos: uniqueShipToNums};

        // 使用 fetch 发送 POST 请求
        return fetch(getSpecialTagListUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Token: loadIdToken(),
            },
            body: JSON.stringify(requestBody),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('接口调用失败，状态码：' + response.status);
                }
                return response.json();
            })
            .then((data) => {
                return data.data || [];
            })
            .catch((error) => {
                console.error('接口调用失败:', error);
                return []; // 如果请求失败，返回空数组
            });
    };

    onloadHeight = (tabFlag) => {
        if (tabFlag && tabFlag === 2) {
            document.getElementById('header-background').style.height =
                17.5 + 'rem';
        } else {
            document.getElementById('header-background').style.height =
                16 + 'rem';
        }
    };

    handleChangeTab = (item) => {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        //重新计算动态height
        if (
            item['tabFlag'] &&
            (item['tabFlag'] === 1 || item['tabFlag'] === 2)
        ) {
            this.onloadHeight(item['tabFlag']);
            // document.getElementById('header-container').clientHeight + 'px';
        }
        console.log(
            "item['tabFlag']============================",
            item['tabFlag'],
        );
        if (
            document.getElementById('header-container') &&
            document.getElementById('header-background') &&
            document.getElementById('financial-tab')
        ) {
            if (
                item['tabFlag'] &&
                (item['tabFlag'] === 3 || item['tabFlag'] === 4)
            ) {
                document.getElementById('header-background').style.height =
                    document.getElementById('header-container').clientHeight -
                    document.getElementById('financial-tab').clientHeight +
                    'px';
            }
        }
        this.props.history.replace(`/shipmentList/${item.name}`);

        this.setState({tabActive: item.index}, () => {
            this.props.updateShipmentListTabActive({
                $set: this.getTabActiveValue(),
            });

            let financialCheckNum = 0;
            let orderCheckNum = 0;
            let expressCheckNum = 0;

            if (localStorage.getItem('currentFinancialTabValue')) {
                financialCheckNum = this.getCurrentFinancialCheckNum(
                    localStorage.getItem('currentFinancialTabValue'),
                );
            } else {
                financialCheckNum = this.getCurrentFinancialCheckNum(
                    this.state.financialTabValue,
                );
            }
            if (localStorage.getItem('currentOrderTabValue')) {
                orderCheckNum = this.getCurrentOrderCheckNum(
                    localStorage.getItem('currentOrderTabValue'),
                );
            } else {
                orderCheckNum = this.getCurrentOrderCheckNum(
                    this.state.orderTabValue,
                );
            }
            if (localStorage.getItem('currentExpressTabValue')) {
                expressCheckNum = this.getCurrentExpressTypeNum(
                    localStorage.getItem('currentExpressTabValue'),
                );
            } else {
                expressCheckNum = this.getCurrentExpressTypeNum(
                    this.state.expressTypeValue,
                );
            }
            this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
        });
    };

    getTabActiveValue = () => {
        let currentTab = this.state.tabActive;
        let currentTabValue = '';
        if (currentTab === 0) {
            currentTabValue = 'tobeShip';
        } else if (currentTab === 1) {
            currentTabValue = 'onHold';
        } else if (currentTab === 2) {
            currentTabValue = 'receive';
        } else if (currentTab === 3) {
            currentTabValue = 'complete';
        } else {
            currentTabValue = 'tobeShip';
        }

        return currentTabValue;
    };

    handleChangeSubTab = (subTabItem) => {
        let subTabIndex = subTabItem.index;
        let currentFinancialStatusDropUp = true;
        let currentOrderStatusDropUp = true;
        let currentExpressTypeDropUp = true;
        let checkNum = 1;
        if (this.state.showLockinStatus) {
            this.setState({
                showLockinStatus: false,
            });
            currentFinancialStatusDropUp = false;
            currentOrderStatusDropUp = false;
            currentExpressTypeDropUp = false;
            if (subTabIndex === 1) {
                this.orderStatus &&
                    this.orderStatus.map((subTab, i) => {
                        if (subTab.value === this.state.orderTabValue) {
                            checkNum = subTab.key;
                        }
                    });
            } else if (subTabIndex === 0) {
                this.financialStatus &&
                    this.financialStatus.map((subTab, i) => {
                        if (subTab.value === this.state.financialTabValue) {
                            checkNum = subTab.key;
                        }
                    });
            } else if (subTabIndex === 2) {
                this.expressType &&
                    this.expressType.map((subTab, i) => {
                        if (subTab.value === this.state.expressTypeValue) {
                            checkNum = subTab.key;
                        }
                    });
            }
        } else {
            this.setState({
                showLockinStatus: true,
            });
            if (this.state.subTabActive === subTabIndex) {
                if (subTabIndex === 0) {
                    if (this.state.financialStatusDropUp) {
                        currentFinancialStatusDropUp = false;
                    } else {
                        currentFinancialStatusDropUp = true;
                    }
                    currentOrderStatusDropUp = false;
                    currentExpressTypeDropUp = false;
                    this.state.subTabList &&
                        this.state.subTabList.map((subTab, i) => {
                            if (subTab.value === this.state.financialTabValue) {
                                checkNum = subTab.key;
                            }
                        });
                } else if (subTabIndex === 1) {
                    if (this.state.orderStatusDropUp) {
                        currentOrderStatusDropUp = false;
                    } else {
                        currentOrderStatusDropUp = true;
                    }
                    currentFinancialStatusDropUp = false;
                    currentExpressTypeDropUp = false;
                    this.state.subTabList &&
                        this.state.subTabList.map((subTab, i) => {
                            if (subTab.value === this.state.orderTabValue) {
                                checkNum = subTab.key;
                            }
                        });
                } else if (subTabIndex === 2) {
                    if (this.state.expressTypeDropUp) {
                        currentExpressTypeDropUp = false;
                    } else {
                        currentExpressTypeDropUp = true;
                    }
                    currentFinancialStatusDropUp = false;
                    currentOrderStatusDropUp = false;
                    this.state.subTabList &&
                        this.state.subTabList.map((subTab, i) => {
                            if (subTab.value === this.state.expressTypeValue) {
                                checkNum = subTab.key;
                            }
                        });
                }
            } else {
                if (!this.state.showLockinStatus) {
                    if (subTabIndex === 1) {
                        currentFinancialStatusDropUp = false;
                        currentOrderStatusDropUp = true;
                        currentExpressTypeDropUp = false;
                        checkNum = this.getCurrentOrderCheckNum(
                            this.state.orderTabValue,
                        );
                    } else if (subTabIndex === 0) {
                        currentFinancialStatusDropUp = true;
                        currentOrderStatusDropUp = false;
                        currentExpressTypeDropUp = false;
                        checkNum = this.getCurrentFinancialCheckNum(
                            this.state.financialTabValue,
                        );
                    } else if (subTabIndex === 2) {
                        currentExpressTypeDropUp = true;
                        currentFinancialStatusDropUp = false;
                        currentOrderStatusDropUp = false;
                        checkNum = this.getCurrentExpressTypeNum(
                            this.state.expressTypeValue,
                        );
                    }
                } else {
                    if (subTabIndex === 0) {
                        currentFinancialStatusDropUp = true;
                        currentOrderStatusDropUp = false;
                        currentExpressTypeDropUp = false;
                    } else if (subTabIndex === 1) {
                        currentFinancialStatusDropUp = false;
                        currentExpressTypeDropUp = false;
                        currentOrderStatusDropUp = true;
                    } else if (subTabIndex === 2) {
                        currentFinancialStatusDropUp = false;
                        currentOrderStatusDropUp = false;
                        currentExpressTypeDropUp = true;
                    }
                }
            }
        }
        if (subTabIndex === 0) {
            setTimeout(() => {
                this.setState({
                    subTabList: this.financialStatus,
                    subTabActive: 0,
                    financialStatusDropUp: currentFinancialStatusDropUp,
                    orderStatusDropUp: currentOrderStatusDropUp,
                    expressTypeDropUp: currentExpressTypeDropUp,
                    currentChecked: checkNum,
                });
            }, 10);
        } else if (subTabIndex === 1) {
            setTimeout(() => {
                this.setState({
                    subTabList: this.orderStatus,
                    subTabActive: 1,
                    financialStatusDropUp: currentFinancialStatusDropUp,
                    orderStatusDropUp: currentOrderStatusDropUp,
                    expressTypeDropUp: currentExpressTypeDropUp,
                    currentChecked: checkNum,
                });
            }, 10);
        } else if (subTabIndex === 2) {
            setTimeout(() => {
                this.setState({
                    subTabList: this.expressType,
                    subTabActive: 2,
                    financialStatusDropUp: currentFinancialStatusDropUp,
                    orderStatusDropUp: currentOrderStatusDropUp,
                    expressTypeDropUp: currentExpressTypeDropUp,
                    currentChecked: checkNum,
                });
            }, 10);
        }
    };

    handleChangeStatus = (subTabActive, statusItem) => {
        let isShowLockin = true;
        let isFinancialStatusDropUp = true;
        let isOrderStatusDropUp = true;
        let isExpressStatusDropUp = true;
        let financialValue = this.state.financialTabValue;
        let orderValue = this.state.orderTabValue;
        let expressValue = this.state.expressTypeValue;

        if (this.state.showLockinStatus) {
            isShowLockin = false;
        }

        if (subTabActive === 0) {
            if (!this.state.showLockinStatus) {
                isFinancialStatusDropUp = true;
                isOrderStatusDropUp = false;
                isExpressStatusDropUp = false;
            } else {
                isFinancialStatusDropUp = false;
                isOrderStatusDropUp = false;
                isExpressStatusDropUp = false;
            }
            financialValue = statusItem.value;
        } else if (subTabActive === 1) {
            if (!this.state.showLockinStatus) {
                isFinancialStatusDropUp = false;
                isExpressStatusDropUp = false;
                isOrderStatusDropUp = true;
            } else {
                isFinancialStatusDropUp = false;
                isOrderStatusDropUp = false;
                isExpressStatusDropUp = false;
            }
            orderValue = statusItem.value;
        } else if (subTabActive === 2) {
            if (!this.state.showLockinStatus) {
                isFinancialStatusDropUp = false;
                isOrderStatusDropUp = false;
                isExpressStatusDropUp = true;
            } else {
                isFinancialStatusDropUp = false;
                isOrderStatusDropUp = false;
                isExpressStatusDropUp = false;
            }
            expressValue = statusItem.value;
        }

        if (localStorage.getItem('currentFinancialTabValue')) {
            localStorage.setItem('currentFinancialTabValue', financialValue);
        }
        if (localStorage.getItem('currentOrderTabValue')) {
            localStorage.setItem('currentOrderTabValue', orderValue);
        }
        if (localStorage.getItem('currentExpressTabValue')) {
            localStorage.setItem('currentExpressTabValue', expressValue);
        }

        this.setState({
            showLockinStatus: isShowLockin,
            financialTabValue: financialValue,
            orderTabValue: orderValue,
            expressTypeValue: expressValue,
            financialStatusDropUp: isFinancialStatusDropUp,
            orderStatusDropUp: isOrderStatusDropUp,
            expressTypeDropUp: isExpressStatusDropUp,
            currentChecked: statusItem.key,
        });

        let financialCheckNum =
            this.getCurrentFinancialCheckNum(financialValue);
        let orderCheckNum = this.getCurrentOrderCheckNum(orderValue);
        let expressTypeNum = this.getCurrentExpressTypeNum(expressValue);

        this.pager.length = 10;
        this.pager.page = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        this.pager.total = 0;
        this.getList(financialCheckNum, orderCheckNum, expressTypeNum);
    };

    getCurrentFinancialCheckNum = (financialValue) => {
        let financialCheckNum = 1;
        this.financialStatus.map((subTab, i) => {
            if (subTab.value === financialValue) {
                financialCheckNum = subTab.key;
            }
        });
        return financialCheckNum;
    };

    getCurrentOrderCheckNum = (orderValue) => {
        let orderCheckNum = 4;
        this.orderStatus.map((orderSubTab, i) => {
            if (orderSubTab.value === orderValue) {
                orderCheckNum = orderSubTab.key;
            }
        });
        return orderCheckNum;
    };

    getCurrentExpressTypeNum = (expressValue) => {
        let expressNum = 7;
        this.expressType.map((expressSubTab, i) => {
            if (expressSubTab.value === expressValue) {
                expressNum = expressSubTab.key;
            }
        });
        return expressNum;
    };

    getList = (financialCheckNum, orderCheckNum, expressCheckNum) => {
        const {tabList, tabActive, todayPlanChecked} = this.state;
        const tab = tabList[tabActive];
        const requestTabName = tab.name;

        this.props.setShipmentsSource({$set: false});

        console.log(
            'this.pager.pageTotal=============getList',
            this.pager.pageTotal,
        );
        if (this.pager.page >= this.pager.pageTotal) return;

        this.setState({
            listLoaded: false,
            listLoadFailed: false,
            location: tab['tabFlag'],
        });

        let params = {};
        if (tab.tabFlag === 1 || tab.tabFlag === 2) {
            if (this.pager.page >= 1) {
                financialCheckNum = this.getCurrentFinancialCheckNum(
                    this.state.financialTabValue,
                );
                orderCheckNum = this.getCurrentOrderCheckNum(
                    this.state.orderTabValue,
                );
                expressCheckNum = this.getCurrentExpressTypeNum(
                    this.state.expressTypeValue,
                );
            }
            params = {
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tab.tabFlag,
                queryKey: this.props.queryKey,
                finStatus: financialCheckNum,
                ordStatus: orderCheckNum,
                orderByColumn: 'o.id',
                today:
                    tab.tabFlag === 2 && todayPlanChecked
                        ? todayPlanChecked
                        : null,
                isAsc: this.state.currentShipmentSort,
                expressType:
                    expressCheckNum === 9
                        ? ''
                        : expressCheckNum === 7
                        ? 'Direct'
                        : 'Express',
            };
        } else if (tab.tabFlag === 4) {
            params = {
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tab.tabFlag,
                queryKey: this.props.queryKey,
                orderByColumn: 'o.id',
                isAsc: SHIPMENT_SORT.DESC_SORT,
            };
        } else {
            params = {
                pageNum: this.pager.page + 1,
                pageSize: this.pager.length,
                tabFlag: tab.tabFlag,
                queryKey: this.props.queryKey,
            };
        }
        switch (tab.tabFlag) {
            case 1:
            case 2:
            case 4:
                return this.props
                    .getOrderList(params)
                    .then((res) => {
                        console.log(
                            'this.props.shipmentTab',
                            this.props.shipmentTab,
                        );
                        console.log('res.tab', res.tab);
                        if (res.tab && this.props.shipmentTab === res.tab) {
                            this.pager.page = res.pageNum;
                            this.pager.pageTotal = res.pageTotal;
                            this.pager.total = res.pageTotal;
                            this.setState({
                                listLoaded: true,
                                listLoadFailed: false,
                            });
                        }
                    })
                    .catch(() => {
                        const currentTab =
                            this.state.tabList[this.state.tabActive];
                        if (currentTab.name === requestTabName) {
                            this.setState({
                                listLoaded: true,
                                listLoadFailed: true,
                            });
                        }
                    });
            default:
                return this.props
                    .getShipmentList({
                        pageNum: this.pager.page + 1,
                        pageSize: this.pager.length,
                        status: 3,
                        queryKey: this.props.queryKey,
                    })
                    .then((res) => {
                        this.pager.page = res.pageNum;
                        this.pager.pageTotal = res.pageTotal;
                        this.pager.total = res.pageTotal;
                        this.setState({listLoaded: true});
                        this.fetchAndMergeData();
                    })
                    .finally(() => {
                        this.setState({listLoaded: true});
                    });
        }
    };

    notShip = () => {
        const {chooseOrderItem} = this.state;

        this.checkOrderStatus(chooseOrderItem).then(() => {
            this.props
                .notShipOrder({orderId: chooseOrderItem.id})
                .then((status) => {
                    this.setState({
                        notShipDialogOpened: false,
                        chooseOrderItem: null,
                    });
                    this.props.openNotification(
                        T(
                            'notification_already_temporarily_does_not_deliver_goods',
                        ),
                        'success',
                    );
                    this.pager.page = 0;
                    this.pager.total = 0;
                    this.pager.pageTotal = 9999999999999999999999999;

                    let financialCheckNum = this.getCurrentFinancialCheckNum(
                        this.state.financialTabValue,
                    );
                    let orderCheckNum = this.getCurrentOrderCheckNum(
                        this.state.orderTabValue,
                    );
                    let expressCheckNum = this.getCurrentExpressTypeNum(
                        this.state.expressTypeValue,
                    );
                    this.getList(
                        financialCheckNum,
                        orderCheckNum,
                        expressCheckNum,
                    );
                })
                .catch((res) => {
                    if (res && res.message) {
                        if (res.message === 'Black_Sku') {
                            this.setState({
                                notShipDialogOpened: false,
                            });
                            this.props.openNotification(
                                T(
                                    'grey_list_products_can_not_be_temporarily_shipped',
                                ),
                                'danger',
                            );
                        }
                    }
                });
        });
    };

    waitShip = () => {
        const {chooseOrderItem} = this.state;

        this.checkOrderStatus(chooseOrderItem).then(() => {
            this.props
                .waitShipOrder({orderId: chooseOrderItem.id})
                .then((status) => {
                    this.setState({
                        waitSendGoodsDialogOpened: false,
                        chooseOrderItem: null,
                    });
                    this.props.openNotification(
                        T('notification_already_wait_query_deliver_list'),
                        'success',
                    );
                    this.pager.page = 0;
                    this.pager.total = 0;
                    this.pager.pageTotal = 9999999999999999999999999;

                    let financialCheckNum = this.getCurrentFinancialCheckNum(
                        this.state.financialTabValue,
                    );
                    let orderCheckNum = this.getCurrentOrderCheckNum(
                        this.state.orderTabValue,
                    );
                    let expressCheckNum = this.getCurrentExpressTypeNum(
                        this.state.expressTypeValue,
                    );
                    this.getList(
                        financialCheckNum,
                        orderCheckNum,
                        expressCheckNum,
                    );
                });
        });
    };

    ship = (item) => {
        if (item.isPicking) {
            this.setState({
                opentForceShipDialog: true,
                currentShipItem: item,
            });
        } else {
            this.getOrderDetailMessageCountHandle(item);
        }
    };

    confirmForceShipHandle = () => {
        this.props
            .forceCancelPickOrder(this.state.currentShipItem.id)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.getOrderDetailMessageCountHandle(
                        this.state.currentShipItem,
                    );
                }
            });
    };

    getOrderDetailMessageCountHandle = (item) => {
        this.saveShipmentRestoreState(item);
        this.checkOrderStatus(item).then(() =>
            this.props.history.push(`/shipEdit/${item.id}`, {
                forceShip: item.isPicking,
                eoneNumber: item.eoneNumber,
            }),
        );
    };

    recommendPdf = (params) => {
        this.setState({pageLoading: true});
        this.props.createRecommendPdf(params).then((res) => {
            this.setState({pageLoading: false});
            if (util.isIOS()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-recommend.html?url=' +
                    window.encodeURIComponent(
                        `${util.getImageRoot() + res.data}`,
                    );
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-recommend.html?url=' +
                        window.encodeURIComponent(
                            `${util.getImageRoot() + res.data}`,
                        ),
                    '_blank',
                );
            }
        });
    };

    checkOrderStatus(item) {
        const {tabList, tabActive} = this.state;

        return new Promise((resolve, reject) => {
            this.props.checkOrderStatus({orderId: item.id}).then((res) => {
                if (res.data === tabList[tabActive].tabFlag) resolve();
                else
                    this.props.openNotification(
                        `${
                            res.data === 4 || res.data === -1
                                ? ''
                                : T('notification_already')
                        }` +
                            `${this.statusList[res.data]}` +
                            T('notification_go_to') +
                            `${this.statusList[res.data]}` +
                            T('notification_list_to_view'),
                        'danger',
                    );
            });
        });
    }

    openUploadReceiveDialog = (item) => {
        this.props.punchReceivable(item.shipments[0].id).then((res) => {
            if (res && res.status === 'success') {
                if (res.data.punchEnabled === 'Y') {
                    if (res.data.hasPunched === 'Y') {
                        this.setState(
                            {
                                uploadReceiveImageDialog: {
                                    opened: true,
                                    shipment: item,
                                    chooseImage: {file: null, url: ''},
                                },
                            },
                            () => {
                                if (this.inputFileRef.current) {
                                    this.inputFileRef.current.value = '';
                                }
                            },
                        );
                    } else {
                        this.props.openNotification(
                            T('shippment_upload_signed_first_punch'),
                            'danger',
                        );
                    }
                } else {
                    this.setState(
                        {
                            uploadReceiveImageDialog: {
                                opened: true,
                                shipment: item,
                                chooseImage: {file: null, url: ''},
                            },
                        },
                        () => {
                            if (this.inputFileRef.current) {
                                this.inputFileRef.current.value = '';
                            }
                        },
                    );
                }
            }
        });
    };

    addTrackNumberDialog = (item) => {
        this.setState({
            addTrackNumberDialogOpened: true,
            currentShipments: item,
            trackNumber:
                item.shipments.length > 0 && item.shipments[0].expressNumber,
        });
    };

    handleChange = (name, value) => {
        this.setState({
            trackNumber: value,
        });
    };
    addTrackNumberHandle = () => {
        let {trackNumber, currentShipments} = this.state;
        let shipmentId =
            currentShipments &&
            currentShipments.shipments.length > 0 &&
            currentShipments.shipments[0].id;

        if (trackNumber.trim()) {
            this.props
                .updateTrackingNumber({
                    shipmentId: shipmentId,
                    expressNumber: trackNumber.trim(),
                })
                .then(() => {
                    this.props.openNotification(
                        T('shippment_update_tracking_number_success'),
                        'success',
                        {time: 2000},
                    );
                    this.pager.page = 0;
                    this.pager.total = 0;
                    this.pager.pageTotal = 9999999999999999999999999;
                    this.setState({
                        trackNumber: '',
                        addTrackNumberDialogOpened: false,
                        currentShipments: [],
                    });
                    this.getList();
                });
        }
    };

    customerFeedback = (item) => {
        this.props.history.push('/customerFeedBack', {shipmentItem: item});
    };

    shipmentPunchHandle = (item) => {
        this.props.updateShipmentListPageNum({$set: this.pager.page});
        this.props.history.push('/clockedSigned', {shipmentItem: item});
    };

    getShipmentCoaSkus = (shipment) => {
        let skuNumberList = [];

        shipment &&
            shipment.shipmentProducts &&
            shipment.shipmentProducts.forEach((item) => {
                let shipmentProducts = {
                    shipmentProductId: item.id,
                    sku: item.sku,
                };
                skuNumberList.push(shipmentProducts);
            });

        return skuNumberList;
    };

    buildShipmentCoaNotificationRequest = (shipmentOrder, coaItems) => ({
        supplyCenterName: (shipmentOrder && shipmentOrder.scName) || '',
        orderNumber: (shipmentOrder && shipmentOrder.eoneNumber) || '',
        coaItems,
    });

    shipmentCoaDialogClose = () => {
        this.setState({
            shipmentCoaDialogOpened: false,
            shipmentCoaLoading: false,
            shipmentCoaRows: [],
            shipmentCoaApplyCheckPending: false,
            currentShipmentCoaRowForApply: null,
            currentShipmentOrderForCoaApply: null,
        });
    };

    isShipmentCoaKit = (coaRow) => coaRow && Array.isArray(coaRow.components);

    buildShipmentCoaRowRequest = (coaRow) => {
        if (!coaRow) {
            return [];
        }
        if (this.isShipmentCoaKit(coaRow)) {
            return [
                {
                    shipmentProductId: coaRow.shipmentProductId,
                    sku: coaRow.sku,
                },
            ];
        }
        const request = {
            shipmentProductId: coaRow.shipmentProductId,
            sku: coaRow.sku,
        };
        request.lot = coaRow.lot;
        return [request];
    };

    openShipmentCoaApplyDialog = (coaRow) => {
        if (
            !coaRow ||
            (!this.isShipmentCoaKit(coaRow) && !coaRow.lot) ||
            this.state.shipmentCoaApplyCheckPending
        ) {
            return;
        }
        const coaItems = this.buildShipmentCoaRowRequest(coaRow);
        const {currentShipmentOrderForCoaApply} = this.state;
        this.setState({
            shipmentCoaApplyCheckPending: true,
            currentShipmentCoaRowForApply: coaRow,
        });
        this.props
            .checkShipmentCoaApplication(
                this.buildShipmentCoaNotificationRequest(
                    currentShipmentOrderForCoaApply,
                    coaItems,
                ),
            )
            .then((res) => {
                if (res && res.status === 'success' && res.message) {
                    this.setState({
                        shipmentCoaApplyCheckPending: false,
                    });
                    this.openShipmentCoaApplicationPromptDialog(res.message);
                    return;
                }
                this.setState({
                    shipmentCoaApplyDialogOpened: true,
                    shipmentCoaApplyCheckPending: false,
                    currentShipmentCoaRowForApply: coaRow,
                });
            })
            .catch(() => {
                this.setState({
                    shipmentCoaApplyDialogOpened: true,
                    shipmentCoaApplyCheckPending: false,
                    currentShipmentCoaRowForApply: coaRow,
                });
            });
    };

    closeShipmentCoaApplyDialog = () => {
        this.setState({
            shipmentCoaApplyDialogOpened: false,
        });
    };

    openShipmentCoaApplicationPromptDialog = (message) => {
        this.setState({
            shipmentCoaApplicationPromptDialogOpened: true,
            shipmentCoaApplicationPromptMessage: message,
        });
    };

    closeShipmentCoaApplicationPromptDialog = () => {
        this.setState({
            shipmentCoaApplicationPromptDialogOpened: false,
            shipmentCoaApplicationPromptMessage: '',
        });
    };

    showShipmentCoaSuccessToast = () => {
        if (this.shipmentCoaSuccessToastTimer) {
            clearTimeout(this.shipmentCoaSuccessToastTimer);
        }

        this.setState({
            shipmentCoaSuccessToastVisible: true,
        });

        this.shipmentCoaSuccessToastTimer = setTimeout(() => {
            this.setState({
                shipmentCoaSuccessToastVisible: false,
            });
            this.shipmentCoaSuccessToastTimer = null;
        }, 2500);
    };

    confirmShipmentCoaApply = () => {
        const {currentShipmentCoaRowForApply, currentShipmentOrderForCoaApply} =
            this.state;
        const coaItems = this.buildShipmentCoaRowRequest(
            currentShipmentCoaRowForApply,
        );

        this.closeShipmentCoaApplyDialog();

        if (!Array.isArray(coaItems) || !coaItems.length) {
            this.props.openNotification(
                T('shipment_coa_catalog_number_empty'),
                'danger',
            );
            return;
        }

        this.props
            .sendShipmentNotification(
                this.buildShipmentCoaNotificationRequest(
                    currentShipmentOrderForCoaApply,
                    coaItems,
                ),
            )
            .then((res) => {
                if (res && res.status === 'success' && res.message) {
                    this.openShipmentCoaApplicationPromptDialog(res.message);
                    return;
                }

                if (res && res.status === 'success') {
                    this.setState({
                        shipmentCoaDialogOpened: false,
                        shipmentCoaLoading: false,
                        shipmentCoaRows: [],
                        shipmentCoaApplyCheckPending: false,
                        currentShipmentCoaRowForApply: null,
                        currentShipmentOrderForCoaApply: null,
                    });
                    this.showShipmentCoaSuccessToast();
                    return;
                }

                if (res && res.message) {
                    this.openShipmentCoaApplicationPromptDialog(res.message);
                }
            })
            .catch((err) => {
                if (err && err.message) {
                    this.openShipmentCoaApplicationPromptDialog(err.message);
                    return;
                }
                this.props.openNotification(
                    T('shipment_coa_apply_failed'),
                    'danger',
                );
            });
    };

    openShipmentCoaPdf = async (coaItem) => {
        if (!coaItem || !coaItem.lotNoUrl) {
            return;
        }
        const pdfHref = coaItem.lotNoUrl;
        let proxyPdfHref = pdfHref;

        if (util.isWechatBrowser()) {
            try {
                proxyPdfHref = await this.props.getShipmentProxyPdf({
                    pdfHref,
                });
            } catch (err) {
                proxyPdfHref = pdfHref;
            }

            if (util.isIOS()) {
                window.location.href =
                    window.location.origin +
                    '/pdf-preview/pdf-preview.html?url=' +
                    window.encodeURIComponent(
                        `${util.getImageRoot() + proxyPdfHref}`,
                    );
            } else {
                window.open(
                    window.location.origin +
                        '/pdf-preview/pdf-preview.html?url=' +
                        window.encodeURIComponent(
                            `${util.getImageRoot() + proxyPdfHref}`,
                        ),
                    '_blank',
                );
            }
        } else {
            window.open(proxyPdfHref, '_blank');
        }
    };

    queryShipmentCoaMore = (coaRow) => {
        if (!coaRow || !coaRow.lot) {
            return;
        }
        const queryUrl =
            'https://www.thermofisher.cn/search/results?query=' +
            window.encodeURIComponent(coaRow.lot) +
            '&persona=DocSupport&focusarea=' +
            window.encodeURIComponent('证书(COA)') +
            '&filter=' +
            window.encodeURIComponent('document.result_type_s:Certificates');
        window.open(queryUrl, '_blank');
    };

    shipmentDocumentCoaHandle = (item) => {
        let currentShipments = item.shipments && item.shipments[0];

        const skus = this.getShipmentCoaSkus(currentShipments);

        console.log('shipmentDocumentCoaHandle skus================', skus);

        if (!Array.isArray(skus) || !skus.length) {
            this.props.openNotification(
                T('shipment_coa_catalog_number_empty'),
                'danger',
            );
            return;
        }

        this.setState({
            shipmentCoaDialogOpened: true,
            shipmentCoaLoading: true,
            shipmentCoaRows: [],
            shipmentCoaApplyCheckPending: false,
            currentShipmentCoaRowForApply: null,
        });

        this.props
            .getShipmentDocumentCoa(skus)
            .then((res) => {
                const shipmentCoaRows = res && res.data ? res.data : [];

                this.setState({
                    shipmentCoaLoading: false,
                    shipmentCoaRows,
                    currentShipmentOrderForCoaApply: item,
                    shipmentCoaApplyCheckPending: false,
                });
            })
            .catch((err) => {
                this.setState({
                    shipmentCoaDialogOpened: false,
                    shipmentCoaLoading: false,
                    shipmentCoaRows: [],
                    shipmentCoaApplyCheckPending: false,
                    currentShipmentCoaRowForApply: null,
                    currentShipmentOrderForCoaApply: null,
                });
                this.props.openNotification(
                    T('shipment_coa_query_failed'),
                    'danger',
                );
            });
    };

    goToTaskDetailsHandle = (item) => {
        this.props.updateShipmentListPageNum({$set: this.pager.page});
        this.props.history.push(`/host/taskDetails/`, {
            tabFlag: 1,
            id: item.taskAssignmentId,
            taskId: item.taskId,
            toBeReceveShipmentItem: item,
            fromShipmentManagementFlag: true,
        });
    };

    b2bCasmartShipmentHandle = (item) => {
        let params = {
            shipmentId:
                item.shipments && item.shipments[0] && item.shipments[0].id,
            orderId: item.id,
        };
        this.props
            .b2bCasmartShipment(params)
            .then((res) => {
                if (res && res.status === 'success') {
                    // console.log(res);
                    // window.open(res.data, '_blank');

                    if (util.isWechatBrowser()) {
                        if (util.isIOS()) {
                            window.location.href =
                                window.location.origin +
                                '/pdf-preview/pdf-preview.html?url=' +
                                window.encodeURIComponent(
                                    `${util.getImageRoot() + res.data}`,
                                );
                        } else {
                            window.open(
                                window.location.origin +
                                    '/pdf-preview/pdf-preview.html?url=' +
                                    window.encodeURIComponent(
                                        `${util.getImageRoot() + res.data}`,
                                    ),
                                '_blank',
                            );
                        }
                    } else {
                        window.open(res.data, '_blank');
                    }
                } else {
                    this.props.openNotification(T(res.message), 'danger');
                }
            })
            .catch((err) => {
                if (err && err.status === 'po_number_empty') {
                    this.props.openNotification(T('po_number_empty'), 'danger');
                } else if (
                    err &&
                    err.status === 'b2b_shipment_integration_error'
                ) {
                    this.props.openNotification(
                        T('order_contact_service'),
                        'danger',
                    );
                } else {
                    this.props.openNotification(T(err.message), 'danger');
                }
            });
    };

    viewB2bCasmartMessageHandle = (e) => {
        if (e && e.stopPropagation) {
            e.stopPropagation();
            this.setState({
                showCasmatMessage: true,
            });
        } else {
            window.e.cancelBubble = true;
        }
    };

    deliverInforHandle = (item) => {
        this.props.history.push(`/deliverDetails?orderId=${item.id}`);
    };

    receive = (receiveMethod, verificationCode) => {
        const {uploadReceiveImageDialog} = this.state;
        const {shipment, chooseImage} = uploadReceiveImageDialog;

        if (this.state.uploadFileBtnIsLoading) {
            return;
        }

        if (!shipment)
            return this.props.openNotification(
                T('notification_please_select_package'),
                'danger',
            );

        this.setState({uploadFileBtnIsLoading: true});

        this.props
            .uploadReceiveImage({
                type: util.getUploadType(receiveMethod),
                file: chooseImage.file,
            })
            .then((res) => {
                this.props
                    .receiveOrder({
                        shipmentId: shipment.shipments[0].id,
                        receiveImg:
                            receiveMethod === RECEIVE_METHOD.CUSTOMER
                                ? res.url
                                : undefined,
                        receiveType:
                            receiveMethod === RECEIVE_METHOD.CUSTOMER ? 1 : 2,
                        receivingCode: verificationCode
                            ? verificationCode.trim()
                            : null,
                        locationImg:
                            receiveMethod === RECEIVE_METHOD.DELEGATE
                                ? res.url
                                : undefined,
                    })
                    .then(() => {
                        this.props.openNotification(
                            T('notification_confirmed_the_customer_receipt'),
                            'success',
                            {testid: 'receipt-success-message', time: 2000},
                        );
                        this.pager.page = 0;
                        this.pager.total = 0;
                        this.pager.pageTotal = 9999999999999999999999999;
                        this.setState({
                            uploadReceiveImageDialog: {
                                opened: false,
                                shipment: null,
                                chooseImage: {file: null, url: ''},
                            },
                        });
                        if (this.inputFileRef.current) {
                            this.inputFileRef.current.value = '';
                        }
                        this.getList();
                    });
            })
            .finally(() => {
                this.setState({uploadFileBtnIsLoading: false});
            });
    };

    chooseItem = (item) => {
        const {tabList, tabActive, location} = this.state;
        this.saveShipmentRestoreState(item);
        if (tabList[tabActive].tabFlag === 3) {
            let shipmentId =
                item.shipments && item.shipments[0] && item.shipments[0].id;

            this.props.history.push(
                `/hostShipmentDetails?orderId=${item.id}&shipmentId=${shipmentId}`,
                location,
            );
        } else {
            if (
                tabList[tabActive].tabFlag === 1 ||
                tabList[tabActive].tabFlag === 2
            ) {
                this.props.history.push(
                    `/shipmentDetails?orderId=${item.id}&eoneNumber=${
                        item.eoneNumber
                    }&shipFlag=${
                        item.shipFlag
                    }&financialStatusFlay=${true}&tabFlag=${
                        tabList[tabActive].tabFlag
                    }`,
                    {forceShip: item.isPicking},
                );
                // this.props.history.push({pathname: "/shipmentDetails",
                //                          state: {orderId: item.id, shipFlag: item.shipFlag, financialStatus: JSON.stringify(financialStatus) }});

                // this.props.history.push(`/shipmentDetails?orderId=${ item.id }&shipFlag=${ item.shipFlag }&financialStatus=${ JSON.stringify(financialStatus) }`);
            } else {
                this.props.history.push(
                    `/shipmentDetails?orderId=${item.id}&eoneNumber=${item.eoneNumber}&tabFlag=${tabList[tabActive].tabFlag}`,
                    location,
                );
            }
        }
    };
    uploadReceiveImage = () =>
        this.inputFileRef.current && this.inputFileRef.current.click();
    clearUploadReceiveImage = () => {
        this.setState((prevState) => ({
            uploadReceiveImageDialog: {
                ...prevState.uploadReceiveImageDialog,
                chooseImage: {file: null, url: ''},
            },
        }));
        if (this.inputFileRef.current) {
            this.inputFileRef.current.value = '';
        }
    };
    selectedImage = (ev) => {
        if (!ev.target.files || !ev.target.files[0]) return;
        if (!/^image\//.test(ev.target.files[0].type)) {
            return this.props.openNotification(
                T('notification_please_select_picture'),
                'danger',
            );
        }
        const reader = new FileReader();
        const file = ev.target.files[0];
        reader.onload = (event) => {
            this.setState((prevState) => ({
                uploadReceiveImageDialog: {
                    ...prevState.uploadReceiveImageDialog,
                    chooseImage: {file, url: event.target.result},
                },
            }));
        };
        reader.readAsDataURL(file);
    };
    uploadReceiveImageDialogClosed = () => {
        if (this.inputFileRef.current) {
            this.inputFileRef.current.value = '';
        }

        if (this.state.uploadReceiveImageDialog.opened) {
            this.setState({
                uploadReceiveImageDialog: {
                    opened: false,
                    shipment: null,
                    chooseImage: {file: null, url: ''},
                },
            });
        }
    };

    openNotShipDialog = (item) =>
        this.setState({chooseOrderItem: item, notShipDialogOpened: true});
    openWaitSendGoodsDialog = (item) =>
        this.setState({chooseOrderItem: item, waitSendGoodsDialogOpened: true});
    dialogDidClose = (dialog) =>
        this.state[dialog] && this.setState({[dialog]: false});

    dialogSpecialTagsClose = (dialog) => {
        this.state[dialog] &&
            this.setState({
                [dialog]: false,
                currentSpecialTagsList: [],
                otherInformantion: '',
            });
    };

    closeCasmatMessage = (event) => {
        event.stopPropagation();
        this.setState({
            showCasmatMessage: false,
        });
    };

    search = () => {
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        let financialCheckNum = 3;
        let orderCheckNum = 6;
        let expressCheckNum = 9;

        let currentFinancialValue = '';
        let currentOrderValue = '';
        let currentExpressValue = '';
        this.financialStatus &&
            this.financialStatus.map((subTab, i) => {
                if (subTab.key === financialCheckNum) {
                    currentFinancialValue = subTab.value;
                }
            });

        this.orderStatus.map((orderSubTab, i) => {
            if (orderSubTab.key === orderCheckNum) {
                currentOrderValue = orderSubTab.value;
            }
        });

        this.expressType.map((expressSubTab, i) => {
            if (expressSubTab.key === expressCheckNum) {
                currentExpressValue = expressSubTab.value;
            }
        });

        localStorage.setItem('currentFinancialTabValue', currentFinancialValue);
        localStorage.setItem('currentOrderTabValue', currentOrderValue);
        localStorage.setItem('currentExpressTabValue', currentExpressValue);
        setTimeout(() => {
            this.setState({
                financialTabValue: currentFinancialValue,
                orderTabValue: currentOrderValue,
                expressTypeValue: currentExpressValue,
            });
        });
        this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
    };

    onChange = (title, value) =>
        this.props.updateShipmentSearchFields({
            [title]: {$set: value},
        });
    goBack = (params) => {
        localStorage.setItem('currentFinancialTabValue', '');
        localStorage.setItem('currentOrderTabValue', '');
        localStorage.setItem('currentExpressTabValue', '');
        localStorage.setItem('currentSortResult', '');
        localStorage.setItem('currentTodayPlanChecked', '');
        this.props.history.goBack();
    };

    getCurrentTabId = (item) => {
        let currentId = '';
        switch (item.tabFlag) {
            case 1:
                currentId = 'to_be_shipped';
                break;
            case 2:
                currentId = 'on_hold';
                break;
            case 3:
                currentId = 'to_be_recieved';
                break;
            case 4:
                currentId = 'complete';
                break;
            default:
                break;
        }
        return currentId;
    };

    getCurrentStatus = (subTabActive, statusItem) => {
        // subTabActive ===0 && statusItem.key === 1 ? <Check/>
        if (subTabActive === 0) {
            if (statusItem.key === 1) {
                return statusItem.key;
            } else if (statusItem.key === 2) {
                return statusItem.key;
            } else if (statusItem.key === 3) {
                return statusItem.key;
            }
        }
    };

    goMyOrderPicking = () => {
        this.props.history.push(`/myOrderPick`);
    };

    previewPickOrderHandle = (orderId, displayPrice) => {
        this.setState({
            previewPickOrderDialog: true,
            currentOrderId: orderId,
            currentDisplayPrice: displayPrice,
        });
    };

    /**
     * displayPrice: 0表示没有人设置是否显示价格如果没人默认为显示价格, 1表示显示价格, 2表示不显示价格
     * pickType: byOrder是基于订单列表的预拣货，bySku是基于单个发货页面的预拣货
     */
    confirmPreviewPickOrderHandle = () => {
        let pickParams = {
            orderId: this.state.currentOrderId,
            pickType: 'byOrder',
            displayPrice:
                parseInt(this.state.currentDisplayPrice) === 0 ||
                parseInt(this.state.currentDisplayPrice) === 1
                    ? 1
                    : 2,
        };
        // console.log(this.state.currentDisplayPrice, pickParams);
        this.props
            .savePickOrder(pickParams)
            .then((res) => {
                if (res && res.status === 'success') {
                    this.setState({
                        previewPickOrderDialog: false,
                        currentOrderId: 0,
                        currentDisplayPrice: 1,
                    });
                    this.updateList();
                    this.props.openNotification(
                        T('shipment_preview_pick_order_success'),
                        'success',
                    );
                }
            })
            .catch((res) => {
                if (res && res.status === 'Empty_Sku_List') {
                    this.props.openNotification(
                        T('shipment_preview_pick_order_sku_shipment_is_null'),
                        'danger',
                    );
                } else if (
                    res &&
                    res.status === 'ShipQuantity_Large_Then_TobeShipped'
                ) {
                    this.props.openNotification(
                        T(
                            'shipment_preview_delivered_quantity_greater_than__undelivered_quantity',
                            [res.message],
                        ),
                        'danger',
                    );
                } else if (res && res.status === 'Order_Not_Exist') {
                    //订单不存在
                    this.props.openNotification(
                        T('shipment_preview_order_non_existent'),
                        'danger',
                    );
                } else if (res && res.status === 'invalid_status') {
                    //订单状态不正确
                    this.props.openNotification(
                        T('shipment_preview_inconsistent_order_status'),
                        'danger',
                    );
                } else if (res && res.status === 'not_allowed') {
                    //订单类型不正确
                    this.props.openNotification(
                        T('shipment_preview_inconsistent_order_type'),
                        'danger',
                    );
                } else if (res && res.status === 'invalid_lock') {
                    //订单审核中或有锁
                    this.props.openNotification(
                        T('shipment_preview_lock_or_review_order'),
                        'danger',
                    );
                } else if (res && res.status === 'Order_Over_Picked') {
                    //订单已拣货
                    this.props.openNotification(
                        T('shipment_preview_order_has_been_picked'),
                        'danger',
                    );
                } else if (res && res.status === 'No_Component_Sku') {
                    //kit下的部分sku缺失
                    this.props.openNotification(
                        T('shipment_preview_no_component_sku'),
                        'danger',
                    );
                } else if (
                    res &&
                    res.status === 'Component_Quantity_Incorrect'
                ) {
                    //sku 数量不正确
                    this.props.openNotification(
                        T('shipment_preview_component_quantity_incorrect'),
                        'danger',
                    );
                } else if (res && res.status === 'Component_Suit_Incorrect') {
                    //component 套数不一致
                    this.props.openNotification(
                        T('shipment_preview_component_suit_incorrect'),
                        'danger',
                    );
                } else if (res && res.status === 'ShipQuantity_Zero') {
                    //某个sku 套数为0
                    this.props.openNotification(
                        T('shipment_preview_ship_quantity_zero'),
                        'danger',
                    );
                } else if (res && res.status === 'Ship_Quantity_Incorrect') {
                    //发货数量大于未发货数量
                    this.props.openNotification(
                        T('shipment_preview_ship_quantity_incorrect'),
                        'danger',
                    );
                }

                this.setState({
                    previewPickOrderDialog: false,
                    currentOrderId: 0,
                    currentDisplayPrice: 1,
                });
            });
    };

    updateList = () => {
        this.pager.page = 0;
        let financialCheckNum = this.getCurrentFinancialCheckNum(
            this.state.financialTabValue,
        );
        let orderCheckNum = this.getCurrentOrderCheckNum(
            this.state.orderTabValue,
        );
        let expressCheckNum = this.getCurrentExpressTypeNum(
            this.state.expressTypeValue,
        );
        this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
    };

    shipmentSort = (sortType) => {
        this.pager.page = 0;
        let financialCheckNum = this.getCurrentFinancialCheckNum(
            this.state.financialTabValue,
        );
        let orderCheckNum = this.getCurrentOrderCheckNum(
            this.state.orderTabValue,
        );
        let expressCheckNum = this.getCurrentExpressTypeNum(
            this.state.expressTypeValue,
        );
        this.setState(
            {
                currentShipmentSort:
                    sortType === SHIPMENT_SORT.ASC_SORT
                        ? SHIPMENT_SORT.DESC_SORT
                        : SHIPMENT_SORT.ASC_SORT,
            },
            () => {
                localStorage.setItem(
                    'currentSortResult',
                    this.state.currentShipmentSort,
                );
                this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
            },
        );
    };

    preShipmentMoreHandle = () => {};

    todayPlanHandleCheck = (name) => (event) => {
        console.log(
            'event.target.checked==================todayPlanHandleCheck==========',
            event.target.checked,
        );
        this.pager.page = 0;
        this.pager.total = 0;
        this.pager.pageTotal = 9999999999999999999999999;
        let financialCheckNum = this.getCurrentFinancialCheckNum(
            this.state.financialTabValue,
        );
        let orderCheckNum = this.getCurrentOrderCheckNum(
            this.state.orderTabValue,
        );
        let expressCheckNum = this.getCurrentExpressTypeNum(
            this.state.expressTypeValue,
        );

        this.setState(
            {
                todayPlanChecked: event.target.checked,
            },
            () => {
                localStorage.setItem(
                    'currentTodayPlanChecked',
                    this.state.todayPlanChecked,
                );
                this.getList(financialCheckNum, orderCheckNum, expressCheckNum);
            },
        );
    };

    viewSpecialTagsHandle = (item) => {
        console.log('viewSpecialTagsHandle==================item', item);

        this.setState({
            showSpecialTagsDialogOpened: true,
            currentSpecialTagsList: item.hostSpecialList,
            otherInformantion: item.hostExtend,
        });
    };

    renderShipmentCoaDetailRow = (
        coaRow,
        shipmentProductId,
        isComponent,
        key,
        parentKitSku,
    ) => {
        const {shipmentCoaApplyCheckPending, currentShipmentCoaRowForApply} =
            this.state;
        const actionRow = {...coaRow, shipmentProductId};

        return (
            <li
                className={`shipment-coa-row ${
                    isComponent ? 'shipment-coa-row--component' : ''
                }`}
                testid={
                    isComponent
                        ? 'shipment-coa-component-row'
                        : 'shipment-coa-row'
                }
                data-sku={coaRow.sku}
                data-lot={coaRow.lot}
                data-parent-kit-sku={isComponent ? parentKitSku : undefined}
                key={key}>
                <div className="shipment-coa-row-text">
                    {coaRow.sku ? (
                        <>
                            {T('shipment_coa_sku')}{' '}
                            <span testid="shipment-coa-item-number">
                                {coaRow.sku}
                            </span>{' '}
                            {' / '}
                        </>
                    ) : null}
                    {T('shipment_coa_batch_no')}{' '}
                    <span testid="shipment-coa-item-lot">
                        {coaRow.lot || '-'}
                    </span>
                </div>
                {coaRow.hasCoa ? (
                    <button
                        type="button"
                        className="shipment-coa-row-action"
                        onClick={() => this.openShipmentCoaPdf(actionRow)}>
                        {T('shipment_coa_download')}
                    </button>
                ) : coaRow.lot ? (
                    <div className="shipment-coa-row-actions">
                        {!isComponent ? (
                            <button
                                type="button"
                                className="shipment-coa-row-action"
                                testid="shipment-coa-apply-btn"
                                onClick={() =>
                                    this.openShipmentCoaApplyDialog(actionRow)
                                }>
                                {shipmentCoaApplyCheckPending &&
                                currentShipmentCoaRowForApply &&
                                currentShipmentCoaRowForApply.shipmentProductId ===
                                    shipmentProductId &&
                                currentShipmentCoaRowForApply.sku ===
                                    coaRow.sku &&
                                currentShipmentCoaRowForApply.lot === coaRow.lot
                                    ? T('shipment_coa_loading')
                                    : T('shipment_coa_apply_now')}
                            </button>
                        ) : null}
                        <button
                            type="button"
                            className="shipment-coa-row-action"
                            testid="shipment-coa-query-more-btn"
                            onClick={() =>
                                this.queryShipmentCoaMore(actionRow)
                            }>
                            {T('shipment_coa_query_more')}
                        </button>
                    </div>
                ) : null}
            </li>
        );
    };

    render() {
        const {
            tabList,
            financialOrdertabList,
            tabActive,
            listLoaded,
            listLoadFailed,
            uploadReceiveImageDialog,
            addTrackNumberDialogOpened,
            notShipDialogOpened,
            waitSendGoodsDialogOpened,
            uploadFileBtnIsLoading,
            pageLoading,
            subTabList,
            subTabActive,
            dropUp,
            financialTabValue,
            orderTabValue,
            showLockinStatus,
            financialStatusDropUp,
            orderStatusDropUp,
            expressTypeDropUp,
            currentChecked,
            trackNumber,
            currentShipments,
            expressTypeValue,
            previewPickOrderDialog,
            opentForceShipDialog,
            currentShipmentSort,
            showCasmatMessage,
            todayPlanChecked,
            currentSpecialTagsList,
            otherInformantion,
            showSpecialTagsDialogOpened,
            shipmentCoaDialogOpened,
            shipmentCoaLoading,
            shipmentCoaRows,
            shipmentCoaApplyDialogOpened,
            shipmentCoaApplyCheckPending,
            currentShipmentCoaRowForApply,
            shipmentCoaApplicationPromptDialogOpened,
            shipmentCoaApplicationPromptMessage,
            shipmentCoaSuccessToastVisible,
        } = this.state;

        let lang = loadLanguage();

        let addContainerClass = '';
        if (this.props.match.params.tab.toLocaleLowerCase() === 'tobeship') {
            addContainerClass = ' to-be-ship-container';
        } else if (
            this.props.match.params.tab.toLocaleLowerCase() === 'onHold'
        ) {
            addContainerClass = ' on-hold-container';
        }

        const currentTab = tabList[tabActive];
        const currentShipmentList =
            this.props.shipmentList[currentTab.name] || [];
        const showListLoadFailed =
            listLoaded && listLoadFailed && currentShipmentList.length === 0;

        return (
            <div className={'shipment-list-container' + addContainerClass}>
                {pageLoading ? (
                    <div className="checkout-loading-mask">
                        <LoadingIcon className="circle-animation" />
                    </div>
                ) : null}

                <Header
                    hasUserCenter={true}
                    hasArrowBackIos={true}
                    backEvent={this.goBack}>
                    <div className="shipment-list-header">
                        <h3 className="header-title">
                            <div className="delivery-title-label">
                                {T('header_delivery_management')}
                            </div>
                            <div
                                className="my-order-picking-link"
                                testid="my-picking-order-btn"
                                onClick={this.goMyOrderPicking}>
                                {T('shipment_my_order_picking')}
                                <Anchor>
                                    <KeyboardArrowRight />
                                </Anchor>
                            </div>
                        </h3>
                        <SearchInput
                            title="queryKey"
                            value={this.props.queryKey}
                            testid="shipment-order-search-input"
                            placeholder={T(
                                'enter_orderNo_eoneNo_sku_subject_receiver_po',
                            )}
                            search={this.search}
                            onChange={this.onChange}></SearchInput>
                    </div>
                    <div className="tab-header">
                        {tabList.map((item, index) => {
                            return (
                                <a
                                    key={item.index}
                                    id={this.getCurrentTabId(item)}
                                    className={util.getClassName({
                                        'tab-item': true,
                                        active: index === tabActive,
                                    })}
                                    onClick={() => {
                                        this.handleChangeTab(item);
                                    }}>
                                    {item.text}
                                </a>
                            );
                        })}
                    </div>
                    {tabActive === 0 || tabActive === 1 ? (
                        <div className="financial-tab" id="financial-tab">
                            <div
                                id="searchContainer"
                                className={
                                    showLockinStatus
                                        ? 'financial-lockin'
                                        : 'financial-lockin hidden-lockin-status'
                                }>
                                <div className="shipment-filter-first-row">
                                    <a
                                        key={financialOrdertabList[0].index}
                                        className="status-tab"
                                        onClick={() => {
                                            this.handleChangeSubTab(
                                                financialOrdertabList[0],
                                            );
                                        }}>
                                        {T('financial_status')}
                                        {financialTabValue}
                                        {financialStatusDropUp ? (
                                            <ArrowDropUp />
                                        ) : (
                                            <ArrowDropDown />
                                        )}
                                    </a>
                                    <a
                                        key={financialOrdertabList[1].index}
                                        className="status-tab"
                                        onClick={() => {
                                            this.handleChangeSubTab(
                                                financialOrdertabList[1],
                                            );
                                        }}>
                                        {T('order_status')}
                                        {orderTabValue}
                                        {orderStatusDropUp ? (
                                            <ArrowDropUp />
                                        ) : (
                                            <ArrowDropDown />
                                        )}
                                    </a>
                                    <a
                                        key={financialOrdertabList[2].index}
                                        className="status-tab"
                                        onClick={() => {
                                            this.handleChangeSubTab(
                                                financialOrdertabList[2],
                                            );
                                        }}>
                                        {T('express_type')}
                                        {expressTypeValue}
                                        {expressTypeDropUp ? (
                                            <ArrowDropUp />
                                        ) : (
                                            <ArrowDropDown />
                                        )}
                                    </a>
                                    <div className="shipments-sort">
                                        {currentShipmentSort ===
                                        SHIPMENT_SORT.ASC_SORT ? (
                                            <img
                                                src={
                                                    new URL(
                                                        'Images/sortup.svg',
                                                        import.meta.url,
                                                    ).href
                                                }
                                                alt=""
                                                onClick={() =>
                                                    this.shipmentSort(
                                                        SHIPMENT_SORT.ASC_SORT,
                                                    )
                                                }
                                            />
                                        ) : (
                                            <img
                                                src={
                                                    new URL(
                                                        'Images/sortdown.svg',
                                                        import.meta.url,
                                                    ).href
                                                }
                                                alt=""
                                                onClick={() =>
                                                    this.shipmentSort(
                                                        SHIPMENT_SORT.DESC_SORT,
                                                    )
                                                }
                                            />
                                        )}
                                    </div>
                                </div>

                                {tabActive === 1 ? (
                                    <div className="today-planning-container">
                                        <div className="first-column">
                                            <Checkbox
                                                checked={todayPlanChecked}
                                                onChange={this.todayPlanHandleCheck(
                                                    'todayPlandChecked',
                                                )}
                                            />
                                            <label>
                                                {T('shipping_plan_today_plan')}
                                            </label>
                                        </div>
                                        <div className="sencond-column"></div>
                                    </div>
                                ) : null}
                            </div>
                            {showLockinStatus ? (
                                <div className="lockin-status">
                                    <ul>
                                        {subTabList.map((statusItem, index) => {
                                            return (
                                                <li
                                                    key={statusItem.key}
                                                    onClick={this.handleChangeStatus.bind(
                                                        this,
                                                        subTabActive,
                                                        statusItem,
                                                    )}>
                                                    {statusItem.value}
                                                    {currentChecked ===
                                                    statusItem.key ? (
                                                        <Check />
                                                    ) : null}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                </div>
                            ) : null}
                        </div>
                    ) : null}
                </Header>
                <ShipmentCoaSuccessToast
                    visible={shipmentCoaSuccessToastVisible}
                    message={T('shipment_coa_apply_success')}
                />
                <ScrollWrapper
                    listLoaded={listLoaded && !showListLoadFailed}
                    showAbyss={
                        !showListLoadFailed &&
                        this.pager.page >= this.pager.pageTotal
                    }
                    showLoadingMore={!showListLoadFailed && !listLoaded}
                    getMoreData={this.handleGetMoreData}>
                    {showListLoadFailed ? (
                        <div className="shipment-list-load-failed">
                            <p className="shipment-list-load-failed-message">
                                {T('shipment_list_load_failed')}
                            </p>
                            <BasicButton
                                type="primary"
                                className="shipment-list-retry-btn"
                                testid="shipment-list-retry-btn"
                                onClickOfSingleTap={this.retryGetList}>
                                {T('shipment_list_reload')}
                            </BasicButton>
                        </div>
                    ) : (
                        <div className="wrapper-list">
                            <ul className="shipment-list" id="shimentListUl">
                                {currentShipmentList.map((item, index) => (
                                    <ShipmentItem
                                        className="shipment-item"
                                        key={index}
                                        anchorId={this.getShipmentAnchorId(
                                            item,
                                        )}
                                        item={item}
                                        b2bShipmentFlag={item.b2bShipmentFlag}
                                        isOrder={
                                            tabList[tabActive].tabFlag !== 3
                                        }
                                        chooseItem={() => this.chooseItem(item)}
                                        notShip={() =>
                                            this.openNotShipDialog(item)
                                        }
                                        waitSendGoods={() =>
                                            this.openWaitSendGoodsDialog(item)
                                        }
                                        ship={() => this.ship(item)}
                                        receive={() =>
                                            this.openUploadReceiveDialog(item)
                                        }
                                        addTrackNumber={() =>
                                            this.addTrackNumberDialog(item)
                                        }
                                        shipmentPunchHandle={() =>
                                            this.shipmentPunchHandle(item)
                                        }
                                        shipmentDocumentCoaHandle={() =>
                                            this.shipmentDocumentCoaHandle(item)
                                        }
                                        goToTaskDetailsHandle={() =>
                                            this.goToTaskDetailsHandle(item)
                                        }
                                        b2bCasmartShipmentHandle={() =>
                                            this.b2bCasmartShipmentHandle(item)
                                        }
                                        customerFeedback={() =>
                                            this.customerFeedback(item)
                                        }
                                        viewB2bCasmartMessageHandle={(event) =>
                                            this.viewB2bCasmartMessageHandle(
                                                event,
                                            )
                                        }
                                        shipFlag={item.shipFlag}
                                        recommendPdf={() =>
                                            this.recommendPdf(item.id)
                                        }
                                        deliverInfor={() =>
                                            this.deliverInforHandle(item)
                                        }
                                        previewPickOrderHandle={() =>
                                            this.previewPickOrderHandle(
                                                item.id,
                                                item.displayPrice,
                                            )
                                        }
                                        preShipmentMoreHandle={() =>
                                            this.preShipmentMoreHandle(item)
                                        }
                                        viewSpecialTagsHandle={
                                            this.viewSpecialTagsHandle
                                        }
                                        status={
                                            tabList[tabActive].tabFlag === 3
                                                ? item.shipments &&
                                                  item.shipments.length &&
                                                  item.shipments[0].status
                                                : item.status
                                        }
                                        options={{
                                            showBuyTime:
                                                tabList[tabActive].tabFlag ===
                                                    1 &&
                                                tabList[tabActive].tabFlag ===
                                                    2,
                                            showShipTime:
                                                tabList[tabActive].tabFlag ===
                                                3,
                                            showReceivedTime:
                                                tabList[tabActive].tabFlag ===
                                                    4 && item.status === 4,
                                            showCancelTime:
                                                tabList[tabActive].tabFlag ===
                                                    4 && item.status === -1,
                                            showReceiveQuantity:
                                                tabList[tabActive].tabFlag ===
                                                4,
                                            showComments:
                                                (tabList[tabActive].tabFlag ===
                                                    1 ||
                                                    tabList[tabActive]
                                                        .tabFlag === 2) &&
                                                item.remark,
                                            showNumber: true,
                                            showSkuList:
                                                tabList[tabActive].tabFlag !==
                                                4,
                                            showTag: true,
                                        }}></ShipmentItem>
                                ))}
                            </ul>
                        </div>
                    )}
                    <BackTop />
                </ScrollWrapper>
                <Dialog
                    opened={shipmentCoaDialogOpened}
                    dialogDidClose={this.shipmentCoaDialogClose}
                    options={{bgClickClose: true}}>
                    <div className="shipment-coa-dialog">
                        <h5 className="shipment-coa-dialog-title">
                            {T('shipment_coa_analysis_certificate')}
                        </h5>
                        <div className="shipment-coa-list">
                            {shipmentCoaLoading ? (
                                <p className="shipment-coa-empty">
                                    {T('shipment_coa_loading')}
                                </p>
                            ) : shipmentCoaRows.length > 0 ? (
                                <ul>
                                    {shipmentCoaRows.map((coaRow, index) =>
                                        this.isShipmentCoaKit(coaRow) ? (
                                            <React.Fragment
                                                key={`kit-${coaRow.sku}-${index}`}>
                                                <li
                                                    className="shipment-coa-kit-row"
                                                    testid="shipment-coa-kit-row"
                                                    data-sku={coaRow.sku}>
                                                    <span>
                                                        {T('shipment_coa_sku')}{' '}
                                                        {coaRow.sku}
                                                    </span>
                                                    {coaRow.components.some(
                                                        (componentRow) =>
                                                            !componentRow.hasCoa &&
                                                            componentRow.lot,
                                                    ) ? (
                                                        <button
                                                            type="button"
                                                            className="shipment-coa-row-action"
                                                            onClick={() =>
                                                                this.openShipmentCoaApplyDialog(
                                                                    coaRow,
                                                                )
                                                            }>
                                                            {shipmentCoaApplyCheckPending &&
                                                            currentShipmentCoaRowForApply &&
                                                            this.isShipmentCoaKit(
                                                                currentShipmentCoaRowForApply,
                                                            ) &&
                                                            currentShipmentCoaRowForApply.shipmentProductId ===
                                                                coaRow.shipmentProductId
                                                                ? T(
                                                                      'shipment_coa_loading',
                                                                  )
                                                                : T(
                                                                      'shipment_coa_apply_now',
                                                                  )}
                                                        </button>
                                                    ) : null}
                                                </li>
                                                {coaRow.components.map(
                                                    (
                                                        componentRow,
                                                        componentIndex,
                                                    ) =>
                                                        this.renderShipmentCoaDetailRow(
                                                            componentRow,
                                                            coaRow.shipmentProductId,
                                                            true,
                                                            `component-${coaRow.sku}-${componentRow.sku}-${componentRow.lot}-${componentIndex}`,
                                                            coaRow.sku,
                                                        ),
                                                )}
                                            </React.Fragment>
                                        ) : (
                                            this.renderShipmentCoaDetailRow(
                                                coaRow,
                                                coaRow.shipmentProductId,
                                                false,
                                                `normal-${coaRow.sku}-${coaRow.lot}-${index}`,
                                            )
                                        ),
                                    )}
                                </ul>
                            ) : (
                                <div className="shipment-coa-empty">
                                    <p className="shipment-coa-empty-text">
                                        {T('shipment_coa_no_data_prefix')}
                                    </p>
                                </div>
                            )}
                        </div>
                        <p className="shipment-coa-lot-empty-text">
                            {T('shipment_coa_lot_null_prefix')}
                        </p>
                        <BasicButton
                            type="primary"
                            className="shipment-coa-close-btn"
                            onClickOfSingleTap={this.shipmentCoaDialogClose}>
                            {T('user_center_close')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={shipmentCoaApplyDialogOpened}
                    dialogDidClose={this.closeShipmentCoaApplyDialog}
                    options={{bgClickClose: true}}>
                    <div
                        className="shipment-coa-apply-dialog"
                        testid="shipment-coa-apply-dialog">
                        <h5
                            className="shipment-coa-apply-dialog-title text-center"
                            testid="shipment-coa-apply-dialog-title">
                            {T('shipment_coa_apply_dialog_title')}
                        </h5>
                        <p
                            className="shipment-coa-apply-dialog-desc text-center"
                            testid="shipment-coa-apply-dialog-message">
                            {T('shipment_coa_apply_dialog_desc')}
                        </p>
                        <div className="shipment-coa-apply-dialog-btn-container">
                            <BasicButton
                                type="primary"
                                className="shipment-coa-apply-confirm-btn"
                                testid="shipment-coa-apply-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmShipmentCoaApply
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                testid="shipment-coa-apply-cancel-btn"
                                onClickOfSingleTap={
                                    this.closeShipmentCoaApplyDialog
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={shipmentCoaApplicationPromptDialogOpened}
                    dialogDidClose={
                        this.closeShipmentCoaApplicationPromptDialog
                    }
                    options={{bgClickClose: true}}>
                    <div className="shipment-coa-prompt-dialog">
                        <h5 className="shipment-coa-prompt-dialog-title text-center">
                            {T('shipment_coa_application_repeat')}
                        </h5>
                        <p className="shipment-coa-prompt-dialog-desc text-center">
                            {shipmentCoaApplicationPromptMessage}
                        </p>
                        <BasicButton
                            type="primary"
                            className="shipment-coa-prompt-dialog-close-btn"
                            onClickOfSingleTap={
                                this.closeShipmentCoaApplicationPromptDialog
                            }>
                            {T('user_center_close')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={uploadReceiveImageDialog.opened}
                    dialogDidClose={this.uploadReceiveImageDialogClosed}
                    options={{bgClickClose: !uploadFileBtnIsLoading}}>
                    <ShipmentReceiveWithOtherPhotosDialog
                        opened={uploadReceiveImageDialog.opened}
                        uploadFileBtnIsLoading={uploadFileBtnIsLoading}
                        lang={lang}
                        onClose={this.uploadReceiveImageDialogClosed}
                        maskedPhone={
                            uploadReceiveImageDialog.shipment &&
                            uploadReceiveImageDialog.shipment.receiverTel
                        }
                        shipment={uploadReceiveImageDialog.shipment}
                        shipmentId={
                            uploadReceiveImageDialog.shipment &&
                            uploadReceiveImageDialog.shipment.shipments &&
                            uploadReceiveImageDialog.shipment.shipments[0] &&
                            uploadReceiveImageDialog.shipment.shipments[0].id
                        }
                        onLoadingChange={(loading) =>
                            this.setState({uploadFileBtnIsLoading: loading})
                        }
                        onSuccess={() => {
                            this.props.openNotification(
                                T(
                                    'notification_confirmed_the_customer_receipt',
                                ),
                                'success',
                                {testid: 'receipt-success-message', time: 2000},
                            );
                            this.pager.page = 0;
                            this.pager.total = 0;
                            this.pager.pageTotal = 9999999999999999999999999;
                            this.setState({
                                uploadReceiveImageDialog: {
                                    opened: false,
                                    shipment: null,
                                    chooseImage: {file: null, url: ''},
                                },
                            });
                            this.getList();
                        }}
                    />
                </Dialog>
                <Dialog
                    opened={notShipDialogOpened}
                    testid="shipment_list_onhold_dialog"
                    dialogDidClose={() =>
                        this.dialogDidClose('notShipDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div
                        className="not-ship-dialog"
                        testid="my_order_list_onhold_dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_temporary_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_temporary_delivery')}</p>
                            <p>{T('shippment_see_temporary_delivery_list')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="not-ship-confirm-btn"
                            testid="shipment_list_onhold_dialog_confirm_btn"
                            onClickOfSingleTap={this.notShip}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={showCasmatMessage}
                    dialogDidClose={() =>
                        this.dialogDidClose('showCasmatMessage')
                    }
                    options={{bgClickClose: true}}>
                    <div className="b2b-casmat-dialog">
                        <div className="b2b-casmat-dialog-desc">
                            <p>{T('shippment_b2b_shipping_order_message')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="b2b-casmat-close-btn"
                            onClickOfSingleTap={this.closeCasmatMessage}>
                            {T('cancel')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={waitSendGoodsDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('waitSendGoodsDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="not-ship-dialog">
                        <h5 className="not-ship-dialog-title text-center">
                            {T('shippment_confirm_wait_delivery')}
                        </h5>
                        <div className="not-ship-dialog-desc">
                            <p>{T('shippment_if_wait_delivery')}</p>
                            <p>{T('shippment_see_wait_delivery_list')}</p>
                        </div>
                        <BasicButton
                            type="primary"
                            className="not-ship-confirm-btn"
                            onClickOfSingleTap={this.waitShip}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>
                <Dialog
                    opened={addTrackNumberDialogOpened}
                    dialogDidClose={() =>
                        this.dialogDidClose('addTrackNumberDialogOpened')
                    }
                    options={{bgClickClose: true}}>
                    <div className="track-number-dialog">
                        <h5 className="track-number-dialog-title text-center">
                            {T('shippment_input_tracking_number')}
                        </h5>
                        <div className="input-track-number">
                            <BasicInput
                                placeholder={T(
                                    'shippment_please_input_tracking_number',
                                )}
                                title=""
                                className="track-number-basic-input"
                                defaultValue={
                                    typeof currentShipments !== 'undefined' &&
                                    currentShipments.shipments &&
                                    currentShipments.shipments.length > 0 &&
                                    currentShipments.shipments[0].expressNumber
                                }
                                value={trackNumber}
                                inputValid={this.handleChange}
                            />
                        </div>
                        <BasicButton
                            type="primary"
                            className="add-track-number-confirm-btn"
                            onClickOfSingleTap={this.addTrackNumberHandle}>
                            {T('shippment_confirm')}
                        </BasicButton>
                    </div>
                </Dialog>

                <Dialog
                    opened={previewPickOrderDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('previewPickOrderDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="preview-pick-order-dialog">
                        <h5 className="preview-pick-order-dialog-title text-center">
                            {T('shipment_pick_confirm_preview_pick_order')}
                        </h5>
                        <p className="preview-pick-order-dialog-desc text-center">
                            {T('shipment_pick_is_confirm_preview_pick_order')}
                        </p>
                        <div className="preview-pick-order-btn-container">
                            <BasicButton
                                type="primary"
                                className="preview-pick-order-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmPreviewPickOrderHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose(
                                        'previewPickOrderDialog',
                                    )
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>

                <Dialog
                    opened={opentForceShipDialog}
                    dialogDidClose={() =>
                        this.dialogDidClose('opentForceShipDialog')
                    }
                    options={{bgClickClose: true}}>
                    <div className="force-ship-dialog">
                        <h5 className="force-ship-dialog-title text-center">
                            {T('shipment_order_shippe_separately')}
                        </h5>
                        <p className="force-ship-dialog-desc">
                            {T('shipment_picking_order_is_separately_shipment')}
                        </p>
                        <div className="force-ship-btn-container">
                            <BasicButton
                                type="primary"
                                className="force-ship-confirm-btn"
                                onClickOfSingleTap={
                                    this.confirmForceShipHandle
                                }>
                                {T('order_confirm')}
                            </BasicButton>
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogDidClose('opentForceShipDialog')
                                }>
                                {T('cancel')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
                <Dialog
                    opened={showSpecialTagsDialogOpened}
                    dialogDidClose={() =>
                        this.dialogSpecialTagsClose(
                            'showSpecialTagsDialogOpened',
                        )
                    }
                    options={{bgClickClose: true}}>
                    <div className="special-tags-dialog">
                        <h5 className="special-tags-dialog-title text-center">
                            {T('shipment_list_special_tags')}
                        </h5>
                        <div className="special-tags-container">
                            <ul className="special-tags-list">
                                {currentSpecialTagsList.map((item, index) => {
                                    return (
                                        <li key={index}>
                                            <div className="category-area">
                                                {item.category}
                                            </div>
                                            <div>
                                                {item.subTags.map(
                                                    (subTag, subIndex) => (
                                                        <div
                                                            className="sub-tag-area"
                                                            key={subIndex}>
                                                            {subTag}
                                                        </div>
                                                    ),
                                                )}
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                            {otherInformantion ? (
                                <div className="other-informantion-area">
                                    <div className="category-area">
                                        {T(
                                            'shipment_list_special_tags_other_desc',
                                        )}
                                    </div>
                                    <div className="sub-tag-area">
                                        {otherInformantion}
                                    </div>
                                </div>
                            ) : null}
                        </div>
                        <div className="operation-container">
                            <BasicButton
                                type="primary"
                                className="cancel-confirm-btn"
                                onClickOfSingleTap={() =>
                                    this.dialogSpecialTagsClose(
                                        'showSpecialTagsDialogOpened',
                                    )
                                }>
                                {T('user_center_close')}
                            </BasicButton>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const {host} = state;
    return {
        shipmentList: host.shipmentList,
        queryKey: host.shipmentSearchfields.queryKey,
        fromShipmentDetails: host.fromShipmentDetails,
        currentPageNum: host.currentPageNum,
        punchStatusFlag: host.punchStatusFlag,
        orderRelatedTaskFlag: host.orderRelatedTaskFlag,
        currentShipmentId: host.currentShipmentId,
        revokePackageSuccessFlag: host.revokePackageSuccessFlag,
        shipmentTab: host.shipmentTab,
        currentStNumber: host.currentStNumber,
    };
};

const mapDispatchToProps = {
    getOrderList,
    getShipmentList,
    notShipOrder,
    waitShipOrder,
    openNotification,
    receiveOrder,
    checkOrderStatus,
    uploadReceiveImage,
    updateShipmentSearchFields,
    createRecommendPdf,
    updateTrackingNumber,
    getOrderDetailMessageCount,
    savePickOrder,
    forceCancelPickOrder,
    setShipmentsSource,
    updateShipmentListPageNum,
    getFeedbackList,
    feedbackSave,
    punchReceivable,
    setPunchSuccessStatus,
    setOrderRelatedTaskStatus,
    setRevokePackageSuccess,
    updateShipmentList,
    setCurrentShipmentId,
    b2bCasmartShipment,
    updateShipmentListTabActive,
    getShipmentDocumentCoa,
    checkShipmentCoaApplication,
    getShipmentProxyPdf,
    sendShipmentNotification,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShipmentList);
